import React, { useState } from "react";

// Goals Data (moved from your original file)
const goalsData = [
  {
    id: "goal 1",
    title: "Goal 1",
    color: "#1e90ff", // blue
    dateRange: "",
    progress: 0,
    accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
    courses: [
      {
        id: "g1 c1",
        title: "Static Website: HTML CSS & Bootstrap",
        progress: 0,
        accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
        modules: [
          {
            id: "QW9_m1_A0 g1_H c1_7B",
            name: "Introduction to HTML & CSS",
            accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
            topic: [
              {
                id: "QW9_s0_A0 m1_H g1_7B c1_D2E",
                name: "Introduction to Your First Project - Lets Build Together",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s1_A0 m1_H g1_7B c1_D2E",
                name: "Introduction to HTML",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s2_A0 m1_H g1_7B c1_D2E",
                name: "Introduction to HTML | Cheat Sheet",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s3_A0 m1_H g1_7B c1_D2E",
                name: "MCQ Practice - HTML",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s4_A0 m1_H g1_7B c1_D2E",
                name: "Introduction to CSS Part 1",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s5_A0 m1_H g1_7B c1_D2E",
                name: "Introduction to CSS Part 1 | Cheat Sheet",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s6_A0 m1_H g1_7B c1_D2E",
                name: "MCQ Practice - CSS 1",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s7_A0 m1_H g1_7B c1_D2E",
                name: "Introduction to CSS Part 2",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s8_A0 m1_H g1_7B c1_D2E",
                name: "Introduction to CSS Part 2 | Cheat Sheet",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s9_A0 m1_H g1_7B c1_D2E",
                name: "MCQ Practice - CSS 2",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s10_A0 m1_H g1_7B c1_D2E",
                name: "Introduction to CSS Part 3",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s11_A0 m1_H g1_7B c1_D2E",
                name: "Introduction to CSS Part 3 | Cheat Sheet",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s12_A0 m1_H g1_7B c1_D2E",
                name: "MCQ Practice - CSS 3",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
            ],
          },
          {
            id: "QW9_m2_A0 g1_H c1_7B",
            name: "CSS Box Model",
            accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
            topic: [
              {
                id: "QW9_s1_A0 m2_H g1_7B c1_D2E",
                name: "Introduction to CSS Box Model Part 1",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s2_A0 m2_H g1_7B c1_D2E",
                name: "Introduction to CSS Box Model Part 1 | Cheat Sheet",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s3_A0 m2_H g1_7B c1_D2E",
                name: "MCQ Practice - BoxModel 1",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s4_A0 m2_H g1_7B c1_D2E",
                name: "Introduction to CSS Box Model Part 2",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s5_A0 m2_H g1_7B c1_D2E",
                name: "Introduction to CSS Box Model Part 2 | Cheat Sheet",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s6_A0 m2_H g1_7B c1_D2E",
                name: "MCQ Practice - BoxModel 2",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s7_A0 m2_H g1_7B c1_D2E",
                name: "Coding Platform Walk through",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s8_A0 m2_H g1_7B c1_D2E",
                name: "Static Coding Practice 1",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
            ],
          },
          {
            id: "QW9_m3_A0 g1_H c1_7B",
            name: "Bootstrap",
            accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
            topic: [
              {
                id: "QW9_s1_A0 m3_H g1_7B c1_D2E",
                name: "Introduction to Bootstrap Part 1",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s2_A0 m3_H g1_7B c1_D2E",
                name: "Introduction to Bootstrap Part 1 | Cheat Sheet",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s3_A0 m3_H g1_7B c1_D2E",
                name: "MCQ Practice - Bootstrap 1",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s4_A0 m3_H g1_7B c1_D2E",
                name: "Introduction to Bootstrap Part 2",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s5_A0 m3_H g1_7B c1_D2E",
                name: "Introduction to Bootstrap Part 2 | Cheat Sheet",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s6_A0 m3_H g1_7B c1_D2E",
                name: "MCQ Practice - Bootstrap 2",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s7_A0 m3_H g1_7B c1_D2E",
                name: "Static Coding Practice 2",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s8_A0 m3_H g1_7B c1_D2E",
                name: "Static Coding Practice 3",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s9_A0 m3_H g1_7B c1_D2E",
                name: "Static Coding Practice 4",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
            ],
          },
          {
            id: "QW9_m4_A0 g1_H c1_7B",
            name: "Developing Layouts",
            accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
            topic: [
              {
                id: "QW9_s1_A0 m4_H g1_7B c1_D2E",
                name: "Favourite Places Section",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s2_A0 m4_H g1_7B c1_D2E",
                name: "Favourite Places Section | Cheat Sheet",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s3_A0 m4_H g1_7B c1_D2E",
                name: "MCQ Practice - Layout 1",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s4_A0 m4_H g1_7B c1_D2E",
                name: "Approach to Develop a Layout",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s5_A0 m4_H g1_7B c1_D2E",
                name: "Approach to Develop a Layout | Cheat Sheet",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s6_A0 m4_H g1_7B c1_D2E",
                name: "MCQ Practice - Layout 2",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s7_A0 m4_H g1_7B c1_D2E",
                name: "A Note on BootStrap Versions",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s8_A0 m4_H g1_7B c1_D2E",
                name: "Favourite Place Detailed View Section",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s9_A0 m4_H g1_7B c1_D2E",
                name: "Favourite Place Detailed View Section | Cheat Sheet",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s10_A0 m4_H g1_7B c1_D2E",
                name: "MCQ Practice - Layout 3",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s11_A0 m4_H g1_7B c1_D2E",
                name: "Static Coding Practice 5",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s12_A0 m4_H g1_7B c1_D2E",
                name: "Static Coding Practice 6",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
            ],
          },
          {
            id: "QW9_m5_A0 g1_H c1_7B",
            name: "Website Integration",
            accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
            topic: [
              {
                id: "QW9_s1_A0 m5_H g1_7B c1_D2E",
                name: "Website Integration Part 1",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s2_A0 m5_H g1_7B c1_D2E",
                name: "Website Integration Part 1 | Cheat Sheet",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s3_A0 m5_H g1_7B c1_D2E",
                name: "MCQ Practice - Website 1",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s4_A0 m5_H g1_7B c1_D2E",
                name: "Website Integration | Part 2",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s5_A0 m5_H g1_7B c1_D2E",
                name: "Website Integration Part 2 | Cheat Sheet",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s6_A0 m5_H g1_7B c1_D2E",
                name: "MCQ Practice - Website 2",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s7_A0 m5_H g1_7B c1_D2E",
                name: "Static Coding Practice 7",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },

              {
                id: "QW9_s10_A0 m5_H g1_7B c1_D2E",
                name: "Website: Behind the Scenes",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },

              {
                id: "QW9_s12_A0 m5_H g1_7B c1_D2E",
                name: "HTML Hyperlinks",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s13_A0 m5_H g1_7B c1_D2E",
                name: "HTML Hyperlinks | Cheat Sheets",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s14_A0 m5_H g1_7B c1_D2E",
                name: "MCQ Practice - HTML Hyperlinks",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s15_A0 m5_H g1_7B c1_D2E",
                name: "OnDemand Session",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s16_A0 m5_H g1_7B c1_D2E",
                name: "OnDemand Session | Cheat Sheet",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s17_A0 m5_H g1_7B c1_D2E",
                name: "MCQ Practice - OnDemand",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s18_A0 m5_H g1_7B c1_D2E",
                name: "Static Coding Practice 8",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
            ],
          },
          {
            id: "QW9_m6_A0 g1_H c1_7B",
            name: "Revision",
            accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
            topic: [
              {
                id: "QW9_s1_A0 m6_H g1_7B c1_D2E",
                name: "Static Summary CheatSheet",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
            ],
          },
          {
            id: "QW9_m7_A0 g1_H c1_7B",
            name: "Assignments",
            accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
            topic: [
              {
                id: "QW9_s1_A0 m7_H g1_7B c1_D2E",
                name: "Static MCQ Assignment 1",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s2_A0 m7_H g1_7B c1_D2E",
                name: "Static MCQ Assignment 2",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s3_A0 m7_H g1_7B c1_D2E",
                name: "Static MCQ Assignment 3",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s4_A0 m7_H g1_7B c1_D2E",
                name: "Static MCQ Assignment 4",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s5_A0 m7_H g1_7B c1_D2E",
                name: "Static Coding Assignment 1",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s6_A0 m7_H g1_7B c1_D2E",
                name: "Static Coding Assignment 2",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s7_A0 m7_H g1_7B c1_D2E",
                name: "Static Coding Assignment 3",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
            ],
          },
          {
            id: "QW9_m8_A0 g1_H c1_7B",
            name: "Mock Tests",
            accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
            topic: [
              {
                id: "QW9_s1_A0 m8_H g1_7B c1_D2E",
                name: "Static Coding Test 1",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s2_A0 m8_H g1_7B c1_D2E",
                name: "Static Coding Test 2",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s3_A0 m8_H g1_7B c1_D2E",
                name: "Build Your Own Static Website Project",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
            ],
          },
          // {
          //   id: "QW9_m9_A0 g1_H c1_7B",
          //   name: "Build Your Own Static Website Course Exam",
          //   topic: [
          //     {
          //       id: "QW9_s1_A0 m9_H g1_7B c1_D2E",
          //       name: "Build Your Own Static Website Course Exam | Instructions",
          //     },
          //     {
          //       id: "QW9_s2_A0 m9_H g1_7B c1_D2E",
          //       name: "Build Your Own Static Website Course Exam",
          //     },
          //   ],
          // },
        ],
      },
      {
        id: "g1 c2",
        title: "Responsive Website: HTML CSS & Bootstrap",
        progress: 0,
        accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],

        modules: [
          {
            id: "QW9_m1_A0 g1_H c2_7B",
            name: "Responsive Web Design & BootStrap Grid System",
            accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
            topic: [
              {
                id: "QW9_s1_A0 m1_H g1_7B c2_D2E",
                name: "Introduction to Responsive Web Design",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s2_A0 m1_H g1_7B c2_D2E",
                name: "Introduction to Responsive Web Design | Cheat Sheet",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s3_A0 m1_H g1_7B c2_D2E",
                name: "MCQ Practice - Res_WD",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s4_A0 m1_H g1_7B c2_D2E",
                name: "BootStrap Grid System Part 1",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s5_A0 m1_H g1_7B c2_D2E",
                name: "BootStrap Grid System Part 1 | Cheat Sheet",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s6_A0 m1_H g1_7B c2_D2E",
                name: "MCQ Practice - B_GS_1",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s7_A0 m1_H g1_7B c2_D2E",
                name: "BootStrap Grid System Part 2",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s8_A0 m1_H g1_7B c2_D2E",
                name: "BootStrap Grid System Part 2 | Cheat Sheet",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s9_A0 m1_H g1_7B c2_D2E",
                name: "MCQ Practice - B_GS_2",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s10_A0 m1_H g1_7B c2_D2E",
                name: "BootStrap Navbar",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s11_A0 m1_H g1_7B c2_D2E",
                name: "BootStrap Navbar | Cheat Sheet",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s12_A0 m1_H g1_7B c2_D2E",
                name: "MCQ Practice - B_Nav",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s13_A0 m1_H g1_7B c2_D2E",
                name: "Responsive Coding Practice 1",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s14_A0 m1_H g1_7B c2_D2E",
                name: "Responsive Coding Practice 2",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
            ],
          },
          {
            id: "QW9_m2_A0 g1_H c2_7B",
            name: "CSS Building Blocks",
            accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
            topic: [
              {
                id: "QW9_s1_A0 m2_H g1_7B c2_D2E",
                name: "CSS Selectors & Inheritance",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s2_A0 m2_H g1_7B c2_D2E",
                name: "CSS Selectors & Inheritance | Cheat Sheet",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s3_A0 m2_H g1_7B c2_D2E",
                name: "MCQ Practice - CSS Selectors & Inheritance",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s4_A0 m2_H g1_7B c2_D2E",
                name: "CSS Specificity & Cascade",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s5_A0 m2_H g1_7B c2_D2E",
                name: "CSS Specificity & Cascade | Cheat Sheet",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s6_A0 m2_H g1_7B c2_D2E",
                name: "MCQ Practice - CSS Specificity & Cascade",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s7_A0 m2_H g1_7B c2_D2E",
                name: "Responsive Coding Practice 3",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s8_A0 m2_H g1_7B c2_D2E",
                name: "Responsive Coding Practice 4",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
            ],
          },
          {
            id: "QW9_m3_A0 g1_H c2_7B",
            name: "Developing Layouts",
            accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
            topic: [
              {
                id: "QW9_s1_A0 m3_H g1_7B c2_D2E",
                name: "Banner Section",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s2_A0 m3_H g1_7B c2_D2E",
                name: "Banner Section | Cheat Sheet",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s3_A0 m3_H g1_7B c2_D2E",
                name: "MCQ Practice - Banner Section",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s4_A0 m3_H g1_7B c2_D2E",
                name: "Responsive Coding Practice 5",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s5_A0 m3_H g1_7B c2_D2E",
                name: "Why Choose Us? Section",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s6_A0 m3_H g1_7B c2_D2E",
                name: "Why Choose us? Section | Cheat Sheet",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s7_A0 m3_H g1_7B c2_D2E",
                name: "MCQ Practice - Why Choose Us Section",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s8_A0 m3_H g1_7B c2_D2E",
                name: "Explore New Section",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s9_A0 m3_H g1_7B c2_D2E",
                name: "Explore New Section | Cheat Sheet",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s10_A0 m3_H g1_7B c2_D2E",
                name: "MCQ Practice - Explore Menu Section",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s11_A0 m3_H g1_7B c2_D2E",
                name: "Healthy Food, Delivery and Payment, Thanking Customers Section",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s12_A0 m3_H g1_7B c2_D2E",
                name: "Healthy Food, Delivery and Payment, Thanking Customers Section | Cheat Sheet",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s13_A0 m3_H g1_7B c2_D2E",
                name: "MCQ Practice - Healthy Delivery & Payments",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s14_A0 m3_H g1_7B c2_D2E",
                name: "Responsive Coding Practice 6",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s15_A0 m3_H g1_7B c2_D2E",
                name: "Responsive Coding Practice 7",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s16_A0 m3_H g1_7B c2_D2E",
                name: "Responsive Coding Practice 8",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s17_A0 m3_H g1_7B c2_D2E",
                name: "Responsive Coding Practice 9",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
            ],
          },
          {
            id: "QW9_m4_A0 g1_H c2_7B",
            name: "Developing Layouts 2",
            accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
            topic: [
              {
                id: "QW9_s1_A0 m4_H g1_7B c2_D2E",
                name: "Follow Us Section & More Styling",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s2_A0 m4_H g1_7B c2_D2E",
                name: "Follow Us Section & More Styling | Cheat Sheet",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s3_A0 m4_H g1_7B c2_D2E",
                name: "MCQ Practice - Follow_us",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s4_A0 m4_H g1_7B c2_D2E",
                name: "CSS Gradients & More BootStrap Components",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s5_A0 m4_H g1_7B c2_D2E",
                name: "CSS Gradients & More BootStrap Components | Cheat Sheet",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s6_A0 m4_H g1_7B c2_D2E",
                name: "MCQ Practice - CSS_Gradients",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s7_A0 m4_H g1_7B c2_D2E",
                name: "Responsive Coding Practice 10",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s8_A0 m4_H g1_7B c2_D2E",
                name: "Responsive Coding Practice 11",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s9_A0 m4_H g1_7B c2_D2E",
                name: "Responsive Coding Practice 12",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s10_A0 m4_H g1_7B c2_D2E",
                name: "Responsive Coding Practice 13",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
            ],
          },
          {
            id: "QW9_m5_A0 g1_H c2_7B",
            name: "Developing Layouts Practice",
            accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
            topic: [
              {
                id: "QW9_s1_A0 m5_H g1_7B c2_D2E",
                name: "Responsive Coding Practice 14",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s2_A0 m5_H g1_7B c2_D2E",
                name: "Responsive Coding Practice 15",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s3_A0 m5_H g1_7B c2_D2E",
                name: "Responsive Coding Practice 16",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
            ],
          },
          {
            id: "QW9_m6_A0 g1_H c2_7B",
            name: "Revision",
            accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
            topic: [
              {
                id: "QW9_s1_A0 m6_H g1_7B c2_D2E",
                name: "Responsive Summary CheatSheet",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
            ],
          },
          {
            id: "QW9_m7_A0 g1_H c2_7B",
            name: "Assignments",
            accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
            topic: [
              {
                id: "QW9_s1_A0 m7_H g1_7B c2_D2E",
                name: "Responsive MCQ Assignment 1",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s2_A0 m7_H g1_7B c2_D2E",
                name: "Responsive MCQ Assignment 2",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s3_A0 m7_H g1_7B c2_D2E",
                name: "Responsive MCQ Assignment 3",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },

              {
                id: "QW9_s4_A0 m7_H g1_7B c2_D2E",
                name: "Responsive Coding Assignment 1",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s5_A0 m7_H g1_7B c2_D2E",
                name: "Responsive Website Project",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              // {
              //   id: "QW9_s6_A0 m7_H g1_7B c2_D2E",
              //   name: "Responsive Coding Assignment 3",
              // },
            ],
          },
          {
            id: "QW9_m8_A0 g1_H c2_7B",
            name: "Mock Tests",
            accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
            topic: [
              {
                id: "QW9_s1_A0 m8_H g1_7B c2_D2E",
                name: "Reponsive Coding Test 1",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s2_A0 m8_H g1_7B c2_D2E",
                name: "Responsive Coding Test 2",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s3_A0 m8_H g1_7B c2_D2E",
                name: "Responsive Coding Test 3",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              // {
              //   id: "QW9_s4_A0 m8_H g1_7B c2_D2E",
              //   name: "Build Your Own Responsive Project",
              // },
            ],
          },
          // {
          //   id: "QW9_m9_A0 g1_H c2_7B",
          //   name: "Build Your Own Responsive Website Course Exam",
          //   topic: [
          //     {
          //       id: "QW9_s1_A0 m9_H g1_7B c2_D2E",
          //       name: "Build Your Own Responsive Website Course Exam | Instructions",
          //     },
          //     {
          //       id: "QW9_s2_A0 m9_H g1_7B c2_D2E",
          //       name: "Build Your Own Responsive Website Course Exam",
          //     },
          //   ],
          // },
        ],
      },
      {
        id: "g1 c3",
        title: "Programming Foundations: Python",
        progress: 0,
        accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
        modules: [
          {
            id: "QW9_m1_A0 g1_H c3_7B",
            name: "Introduction to Python",
            accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
            topic: [
              {
                id: "QW9_s1_A0 m1_H g1_7B c3_D2E",
                name: "Programming with Python",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s2_A0 m1_H g1_7B c3_D2E",
                name: "Programming with Python | Cheat Sheet",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s3_A0 m1_H g1_7B c3_D2E",
                name: "MCQ Practice - Prog with Python",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s4_A0 m1_H g1_7B c3_D2E",
                name: "Coding Practice Walkthrough | Part 1",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s5_A0 m1_H g1_7B c3_D2E",
                name: "Coding Practice - 1",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s6_A0 m1_H g1_7B c3_D2E",
                name: "Variables and Data Types",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s7_A0 m1_H g1_7B c3_D2E",
                name: "Variables and Data Types | Cheat Sheet",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s8_A0 m1_H g1_7B c3_D2E",
                name: "MCQ Practice - Var & Data Types",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s9_A0 m1_H g1_7B c3_D2E",
                name: "Coding Practice - 2",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s10_A0 m1_H g1_7B c3_D2E",
                name: "Sequence of Instructions",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s11_A0 m1_H g1_7B c3_D2E",
                name: "Sequence of Instructions | Cheat Sheet",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s12_A0 m1_H g1_7B c3_D2E",
                name: "MCQ Practice - Sequ of Instructions",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s13_A0 m1_H g1_7B c3_D2E",
                name: "Coding Practice - 3",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
            ],
          },
          {
            id: "QW9_m2_A0 g1_H c3_7B",
            name: "I/O Basics",
            accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
            topic: [
              {
                id: "QW9_s1_A0 m2_H g1_7B c3_D2E",
                name: "Input and Output Basics",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s2_A0 m2_H g1_7B c3_D2E",
                name: "Input and Output Basics | Cheat Sheet",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              // {
              //   id: "QW9_s3_A0 m2_H g1_7B c3_D2E",
              //   name: "Coding Practice Walkthrough | Part 2",
              // },
              {
                id: "QW9_s4_A0 m2_H g1_7B c3_D2E",
                name: "MCQ Practice - I/O",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s5_A0 m2_H g1_7B c3_D2E",
                name: "Coding Practice 1A",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s6_A0 m2_H g1_7B c3_D2E",
                name: "Coding Practice 1B",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s7_A0 m2_H g1_7B c3_D2E",
                name: "Coding Practice 1C",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s8_A0 m2_H g1_7B c3_D2E",
                name: "Assignment 1A",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              // {
              //   id: "QW9_s9_A0 m2_H g1_7B c3_D2E",
              //   name: "How to debug your code?",
              // },
              {
                id: "QW9_s10_A0 m2_H g1_7B c3_D2E",
                name: "Type Conversion",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s11_A0 m2_H g1_7B c3_D2E",
                name: "Type Conversion | Cheat Sheet",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s12_A0 m2_H g1_7B c3_D2E",
                name: "MCQ Practice - Type Con",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s13_A0 m2_H g1_7B c3_D2E",
                name: "Coding Practice 1D",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s14_A0 m2_H g1_7B c3_D2E",
                name: "Coding Practice 1E",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s15_A0 m2_H g1_7B c3_D2E",
                name: "Coding Practice 1F",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s16_A0 m2_H g1_7B c3_D2E",
                name: "Assignment 1B",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
            ],
          },
          {
            id: "QW9_m3_A0 g1_H c3_7B",
            name: "Operators & Conditional Statements",
            accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
            topic: [
              {
                id: "QW9_s1_A0 m3_H g1_7B c3_D2E",
                name: "Relational Operators",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s2_A0 m3_H g1_7B c3_D2E",
                name: "Relational Operators | Cheat Sheet",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s3_A0 m3_H g1_7B c3_D2E",
                name: "MCQ Practice - Rel Ope",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s4_A0 m3_H g1_7B c3_D2E",
                name: "Coding Practice 2A",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s5_A0 m3_H g1_7B c3_D2E",
                name: "Coding Practice 2B",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s6_A0 m3_H g1_7B c3_D2E",
                name: "Assignment 2A",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s7_A0 m3_H g1_7B c3_D2E",
                name: "Logical Operators",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s8_A0 m3_H g1_7B c3_D2E",
                name: "Logical Operators | Cheat Sheet",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s9_A0 m3_H g1_7B c3_D2E",
                name: "MCQ Practice - Log Ope",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s10_A0 m3_H g1_7B c3_D2E",
                name: "Coding Practice 2C",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s11_A0 m3_H g1_7B c3_D2E",
                name: "Coding Practice 2D",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s12_A0 m3_H g1_7B c3_D2E",
                name: "Coding Practice 2E",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s13_A0 m3_H g1_7B c3_D2E",
                name: "Assignment 2B",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s14_A0 m3_H g1_7B c3_D2E",
                name: "Conditional Statements",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s15_A0 m3_H g1_7B c3_D2E",
                name: "Conditional Statements | Cheat Sheet",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s16_A0 m3_H g1_7B c3_D2E",
                name: "MCQ Practice - Con stmts",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s17_A0 m3_H g1_7B c3_D2E",
                name: "Coding Practice 3A",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s18_A0 m3_H g1_7B c3_D2E",
                name: "Coding Practice 3B",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s19_A0 m3_H g1_7B c3_D2E",
                name: "Assignment 3",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
            ],
          },
          {
            id: "QW9_m4_A0 g1_H c3_7B",
            name: "Nested Conditions",
            accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
            topic: [
              {
                id: "QW9_s1_A0 m4_H g1_7B c3_D2E",
                name: "Problem Solving and Debugging Part 1",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s2_A0 m4_H g1_7B c3_D2E",
                name: "Problem Solving and Debugging Part 2",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s3_A0 m4_H g1_7B c3_D2E",
                name: "Problem Solving and Debugging | Cheat Sheet",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s4_A0 m4_H g1_7B c3_D2E",
                name: "MCQ Practice - Problem Solv Debug",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s5_A0 m4_H g1_7B c3_D2E",
                name: "Coding Practice 4A",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s6_A0 m4_H g1_7B c3_D2E",
                name: "Coding Practice 4B",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s7_A0 m4_H g1_7B c3_D2E",
                name: "Assignment 4",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s8_A0 m4_H g1_7B c3_D2E",
                name: "Nested Conditional Statements",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s9_A0 m4_H g1_7B c3_D2E",
                name: "Nested Conditional Statements | Cheat Sheet",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s10_A0 m4_H g1_7B c3_D2E",
                name: "MCQ Practice - Nested Con",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              // {
              //   id: "QW9_s11_A0 m4_H g1_7B c3_D2E",
              //   name: "Problem Solving Part 1",
              // },
              // {
              //   id: "QW9_s12_A0 m4_H g1_7B c3_D2E",
              //   name: "Coding Practice 5",
              // },
              {
                id: "QW9_s13_A0 m4_H g1_7B c3_D2E",
                name: "Assignment 5",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s14_A0 m4_H g1_7B c3_D2E",
                name: "Coding Practice 6A",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s15_A0 m4_H g1_7B c3_D2E",
                name: "Coding Practice 6B",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s16_A0 m4_H g1_7B c3_D2E",
                name: "Assignment 6",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s17_A0 m4_H g1_7B c3_D2E",
                name: "Grand Assignment 1",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
            ],
          },
          {
            id: "QW9_m5_A0 g1_H c3_7B",
            name: "Loops",
            accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
            topic: [
              {
                id: "QW9_s1_A0 m5_H g1_7B c3_D2E",
                name: "Loops",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s2_A0 m5_H g1_7B c3_D2E",
                name: "Loops | Cheat Sheet",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s3_A0 m5_H g1_7B c3_D2E",
                name: "MCQ Practice - Loops",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s4_A0 m5_H g1_7B c3_D2E",
                name: "Coding Practice 7A",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s5_A0 m5_H g1_7B c3_D2E",
                name: "Coding Practice 7B",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s6_A0 m5_H g1_7B c3_D2E",
                name: "Assignment 7",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s7_A0 m5_H g1_7B c3_D2E",
                name: "For Loop",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s8_A0 m5_H g1_7B c3_D2E",
                name: "For Loop | Cheat Sheet",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s9_A0 m5_H g1_7B c3_D2E",
                name: "MCQ Practice - For Loops",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s10_A0 m5_H g1_7B c3_D2E",
                name: "Coding Practice 8A",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              // {
              //   id: "QW9_s11_A0 m5_H g1_7B c3_D2E",
              //   name: "Problem Solving Part 2",
              // },
              {
                id: "QW9_s12_A0 m5_H g1_7B c3_D2E",
                name: "Coding Practice 8B",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s13_A0 m5_H g1_7B c3_D2E",
                name: "Assignment 8",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s14_A0 m5_H g1_7B c3_D2E",
                name: "Coding Practice 9A",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s15_A0 m5_H g1_7B c3_D2E",
                name: "Coding Practice 9B",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s16_A0 m5_H g1_7B c3_D2E",
                name: "Assignment 9",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s17_A0 m5_H g1_7B c3_D2E",
                name: "Coding Practice 10A",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s18_A0 m5_H g1_7B c3_D2E",
                name: "Coding Practice 10B",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              // {
              //   id: "QW9_s19_A0 m5_H g1_7B c3_D2E",
              //   name: "Problem Solving Part 3",
              // },
              {
                id: "QW9_s20_A0 m5_H g1_7B c3_D2E",
                name: "Coding Practice 10C",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s21_A0 m5_H g1_7B c3_D2E",
                name: "Coding Practice 10D",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s22_A0 m5_H g1_7B c3_D2E",
                name: "Assignment 10A",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              // {
              //   id: "QW9_s23_A0 m5_H g1_7B c3_D2E",
              //   name: "Problem Solving Part 4",
              // },
              {
                id: "QW9_s24_A0 m5_H g1_7B c3_D2E",
                name: "Approach for Hollow Pattern | Cheat Sheet",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s25_A0 m5_H g1_7B c3_D2E",
                name: "Coding Practice 10E",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s26_A0 m5_H g1_7B c3_D2E",
                name: "Coding Practice 10F",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s27_A0 m5_H g1_7B c3_D2E",
                name: "Assignment 10B",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              // {
              //   id: "QW9_s28_A0 m5_H g1_7B c3_D2E",
              //   name: "Foundations Exam 1",
              // },
              {
                id: "QW9_s29_A0 m5_H g1_7B c3_D2E",
                name: "String Methods",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s30_A0 m5_H g1_7B c3_D2E",
                name: "String Methods | Cheat Sheets",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s31_A0 m5_H g1_7B c3_D2E",
                name: "MCQ Practice - String Methods",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s32_A0 m5_H g1_7B c3_D2E",
                name: "String Methods | Additional Reading Material",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s33_A0 m5_H g1_7B c3_D2E",
                name: "Coding Practice 11A",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s34_A0 m5_H g1_7B c3_D2E",
                name: "Coding Practice 11B",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s35_A0 m5_H g1_7B c3_D2E",
                name: "Assignment 11",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
            ],
          },
          {
            id: "QW9_m6_A0 g1_H c3_7B",
            name: "Loop Control Statements",
            accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
            topic: [
              {
                id: "QW9_s1_A0 m6_H g1_7B c3_D2E",
                name: "Problem Solving and Debugging Part 3",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },

              {
                id: "QW9_s3_A0 m6_H g1_7B c3_D2E",
                accessibleTo: ["zorvixe_pro", "zorvixe_elite"],
                name: "Coding Practice 12",
              },
              {
                id: "QW9_s4_A0 m6_H g1_7B c3_D2E",
                name: "Assignment 12",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s5_A0 m6_H g1_7B c3_D2E",
                name: "Nested Loops",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s6_A0 m6_H g1_7B c3_D2E",
                name: "Nested Loops | Cheat Sheet",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s7_A0 m6_H g1_7B c3_D2E",
                name: "MCQ Practice - Nested Loops",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s8_A0 m6_H g1_7B c3_D2E",
                accessibleTo: ["zorvixe_pro", "zorvixe_elite"],
                name: "Problem Solving Part 5",
              },
              {
                id: "QW9_s9_A0 m6_H g1_7B c3_D2E",
                accessibleTo: ["zorvixe_pro", "zorvixe_elite"],
                name: "Problem Solving Part 6",
              },
              {
                id: "QW9_s10_A0 m6_H g1_7B c3_D2E",
                name: "Problem Solving Part 6 | Cheat Sheet",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s11_A0 m6_H g1_7B c3_D2E",
                name: "MCQ Practice - Prob_Sol",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s12_A0 m6_H g1_7B c3_D2E",
                name: "Coding Practice 13A",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s13_A0 m6_H g1_7B c3_D2E",
                name: "Coding Practice 13B",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s14_A0 m6_H g1_7B c3_D2E",
                name: "Assignment 13",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s15_A0 m6_H g1_7B c3_D2E",
                accessibleTo: ["zorvixe_pro", "zorvixe_elite"],
                name: "Problem Solving Part 7",
              },
              {
                id: "QW9_s16_A0 m6_H g1_7B c3_D2E",
                name: "Problem Solving Part 7 | Cheat Sheet",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s17_A0 m6_H g1_7B c3_D2E",
                name: "MCQ Practice - Prob_Sol7",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s18_A0 m6_H g1_7B c3_D2E",
                name: "Coding Practice 14A",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s19_A0 m6_H g1_7B c3_D2E",
                name: "Coding Practice 14B",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s20_A0 m6_H g1_7B c3_D2E",
                name: "Assignment 14",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s21_A0 m6_H g1_7B c3_D2E",
                name: "Coding Practice 15A",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s22_A0 m6_H g1_7B c3_D2E",
                name: "Coding Practice 15B",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s23_A0 m6_H g1_7B c3_D2E",
                name: "Loop Control Statements",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s24_A0 m6_H g1_7B c3_D2E",
                name: "Loop Control Statements | Cheat Sheet",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s25_A0 m6_H g1_7B c3_D2E",
                name: "MCQ Practice - Loop Con Stmts",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s26_A0 m6_H g1_7B c3_D2E",
                name: "Coding Practice 16",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s27_A0 m6_H g1_7B c3_D2E",
                name: "Assignment 16",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s28_A0 m6_H g1_7B c3_D2E",
                name: "Grand Assignment 2",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
            ],
          },
          {
            id: "QW9_m7_A0 g1_H c3_7B",
            name: "Comparing Strings & Naming Variables",
            accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
            topic: [
              {
                id: "QW9_s1_A0 m7_H g1_7B c3_D2E",
                name: "Comparing Strings & Naming Variables",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s2_A0 m7_H g1_7B c3_D2E",
                name: "Comparing Strings & Naming Variables | Cheat Sheet",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s3_A0 m7_H g1_7B c3_D2E",
                name: "MCQ Practice - ComStr_NamVar",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s4_A0 m7_H g1_7B c3_D2E",
                name: "Coding Practice 17A",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s5_A0 m7_H g1_7B c3_D2E",
                name: "Coding Practice 17B",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s6_A0 m7_H g1_7B c3_D2E",
                name: "Assignment 17",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s7_A0 m7_H g1_7B c3_D2E",
                name: "Problem Solving and Debugging Part 4",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s8_A0 m7_H g1_7B c3_D2E",
                name: "Problem Solving and Debugging Part 4 | Cheat Sheet",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s9_A0 m7_H g1_7B c3_D2E",
                name: "Coding Practice 18",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s10_A0 m7_H g1_7B c3_D2E",
                name: "Assignment 18",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s11_A0 m7_H g1_7B c3_D2E",
                name: "Problem Solving and Debugging Part 5",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s12_A0 m7_H g1_7B c3_D2E",
                name: "Problem Solving and Debugging Part 5 | Cheat Sheet",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s13_A0 m7_H g1_7B c3_D2E",
                name: "Coding Practice 19",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s14_A0 m7_H g1_7B c3_D2E",
                name: "Assignment 19",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
            ],
          },
          {
            id: "QW9_m8_A0 g1_H c3_7B",
            name: "Lists",
            accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
            topic: [
              {
                id: "QW9_s1_A0 m8_H g1_7B c3_D2E",
                name: "Lists",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s2_A0 m8_H g1_7B c3_D2E",
                name: "Lists | Cheat Sheet",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s3_A0 m8_H g1_7B c3_D2E",
                name: "MCQ Practice - Lists",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s4_A0 m8_H g1_7B c3_D2E",
                name: "Working with Lists",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s5_A0 m8_H g1_7B c3_D2E",
                name: "Working with Lists | Cheat Sheet",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s6_A0 m8_H g1_7B c3_D2E",
                name: "MCQ Practice - Working_Lists",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s7_A0 m8_H g1_7B c3_D2E",
                name: "Coding Practice 20",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s8_A0 m8_H g1_7B c3_D2E",
                name: "Assignment 20",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
            ],
          },
          {
            id: "QW9_m9_A0 g1_H c3_7B",
            name: "Functions",
            accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
            topic: [
              {
                id: "QW9_s1_A0 m9_H g1_7B c3_D2E",
                name: "List & Strings",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s2_A0 m9_H g1_7B c3_D2E",
                name: "List & Strings | Cheat Sheet",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s3_A0 m9_H g1_7B c3_D2E",
                name: "MCQ Practice - List_Str",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s4_A0 m9_H g1_7B c3_D2E",
                name: "Coding Practice 21A",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s5_A0 m9_H g1_7B c3_D2E",
                name: "Coding Practice 21B",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s6_A0 m9_H g1_7B c3_D2E",
                name: "Assignment 21",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s7_A0 m9_H g1_7B c3_D2E",
                name: "Functions",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s8_A0 m9_H g1_7B c3_D2E",
                name: "Functions | Cheat Sheet",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s9_A0 m9_H g1_7B c3_D2E",
                name: "MCQ Practice - Functions",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s10_A0 m9_H g1_7B c3_D2E",
                name: "Coding Practice 22A",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s11_A0 m9_H g1_7B c3_D2E",
                name: "Coding Practice 22B",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s12_A0 m9_H g1_7B c3_D2E",
                name: "Assignment 22",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s13_A0 m9_H g1_7B c3_D2E",
                name: "Function Arguments",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s14_A0 m9_H g1_7B c3_D2E",
                name: "Function Arguments | Cheat Sheet",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s15_A0 m9_H g1_7B c3_D2E",
                name: "MCQ Practice - Fun_Arg",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s16_A0 m9_H g1_7B c3_D2E",
                name: "Coding Practice 23A",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s17_A0 m9_H g1_7B c3_D2E",
                name: "Coding Practice 23B",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s18_A0 m9_H g1_7B c3_D2E",
                name: "Assignment 23",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s19_A0 m9_H g1_7B c3_D2E",
                accessibleTo: ["zorvixe_pro", "zorvixe_elite"],
                name: "Foundations Exam 2",
              },
            ],
          },
          {
            id: "QW9_m10_A0 g1_H c3_7B",
            name: "Recursion",
            accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
            topic: [
              {
                id: "QW9_s1_A0 m10_H g1_7B c3_D2E",
                name: "Built in Functions",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s2_A0 m10_H g1_7B c3_D2E",
                name: "Built-in Functions | Cheat Sheet",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s3_A0 m10_H g1_7B c3_D2E",
                name: "MCQ Practice - Builtin_Fun",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s4_A0 m10_H g1_7B c3_D2E",
                name: "Coding Practice 24",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s5_A0 m10_H g1_7B c3_D2E",
                name: "Assignment 24",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s6_A0 m10_H g1_7B c3_D2E",
                name: "Function Call Stack & Recursion",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s7_A0 m10_H g1_7B c3_D2E",
                name: "Function Call Stack & Recursion | Cheat Sheet",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s8_A0 m10_H g1_7B c3_D2E",
                name: "MCQ Practice - FunCallStack_Recursion",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s9_A0 m10_H g1_7B c3_D2E",
                name: "Coding Practice 25",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s10_A0 m10_H g1_7B c3_D2E",
                name: "Assignment 25",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s11_A0 m10_H g1_7B c3_D2E",
                name: "List Methods",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s12_A0 m10_H g1_7B c3_D2E",
                name: "List Methods | Cheat Sheet",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s13_A0 m10_H g1_7B c3_D2E",
                name: "MCQ Practice - List Methods",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s14_A0 m10_H g1_7B c3_D2E",
                name: "Coding Practice 26",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s15_A0 m10_H g1_7B c3_D2E",
                name: "Assignment 26",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
            ],
          },
          {
            id: "QW9_m11_A0 g1_H c3_7B",
            name: "Tuples & Sets",
            accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
            topic: [
              {
                id: "QW9_s1_A0 m11_H g1_7B c3_D2E",
                name: "Tuples & Sequences",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s2_A0 m11_H g1_7B c3_D2E",
                name: "Tuples & Sequences | Cheat Sheet",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s3_A0 m11_H g1_7B c3_D2E",
                name: "MCQ Practice - Tuples_Seq",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s4_A0 m11_H g1_7B c3_D2E",
                name: "Sets",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s5_A0 m11_H g1_7B c3_D2E",
                name: "Sets | Cheat Sheet",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s6_A0 m11_H g1_7B c3_D2E",
                name: "MCQ Practice - Sets",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s7_A0 m11_H g1_7B c3_D2E",
                name: "Set Operations",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s8_A0 m11_H g1_7B c3_D2E",
                name: "Set Operations | Cheat Sheet",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s9_A0 m11_H g1_7B c3_D2E",
                name: "MCQ Practice - Set_Ope",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s10_A0 m11_H g1_7B c3_D2E",
                name: "Coding Practice 27",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
            ],
          },
          {
            id: "QW9_m12_A0 g1_H c3_7B",
            name: "Dictionaries",
            accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
            topic: [
              {
                id: "QW9_s1_A0 m12_H g1_7B c3_D2E",
                name: "Problem Solving and Debugging Part 6",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s2_A0 m12_H g1_7B c3_D2E",
                name: "Coding Practice 28",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s3_A0 m12_H g1_7B c3_D2E",
                name: "Nested Lists & String Formatting",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s4_A0 m12_H g1_7B c3_D2E",
                name: "Nested Lists & String Formatting | Cheat Sheet",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s5_A0 m12_H g1_7B c3_D2E",
                name: "MCQ Practice - NestedList_StrFormat",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s6_A0 m12_H g1_7B c3_D2E",
                name: "Coding Practice 29",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s7_A0 m12_H g1_7B c3_D2E",
                name: "Coding Practice 30",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s8_A0 m12_H g1_7B c3_D2E",
                name: "Dictionaries",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s9_A0 m12_H g1_7B c3_D2E",
                name: "Dictionaries | Cheat Sheet",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s10_A0 m12_H g1_7B c3_D2E",
                name: "MCQ Practice - Dictionaries",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s11_A0 m12_H g1_7B c3_D2E",
                name: "Working with Dictionaries",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s12_A0 m12_H g1_7B c3_D2E",
                name: "Working with Dictionaries | Cheat Sheet",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s13_A0 m12_H g1_7B c3_D2E",
                name: "MCQ Practice - Working_Dictionaries",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s14_A0 m12_H g1_7B c3_D2E",
                name: "Problem Solving and Debugging Part 7",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s15_A0 m12_H g1_7B c3_D2E",
                name: "Buil-in Functions | Additional Reading Material",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s16_A0 m12_H g1_7B c3_D2E",
                name: "Coding Practice 31",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s17_A0 m12_H g1_7B c3_D2E",
                name: "Grand Assignment 3",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s18_A0 m12_H g1_7B c3_D2E",
                name: "Grand Assignment 4",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s19_A0 m12_H g1_7B c3_D2E",
                accessibleTo: ["zorvixe_pro", "zorvixe_elite"],
                name: "Foundations Exam 3",
              },
            ],
          },
          // //OOPS CORE START
          // {
          //   id: "QW9_m40_A0 g1_H c3_7B",
          //   name: "Introduction to Object Oriented Programming",
          //   accessibleTo: ["zorvixe_core"],
          //   topic: [
          //     {
          //       id: "QW9_41_A0 m13_H g1_7B c3_D2E",
          //       name: "Introduction to Object Oriented Programming",
          //       accessibleTo: ["zorvixe_core"],
          //     },
          //     {
          //       id: "QW9_42_A0 m13_H g1_7B c3_D2E",
          //       name: "Foundations of Object Oriented Programming | Cheat Sheet",
          //       accessibleTo: ["zorvixe_core"],
          //     },
          //     {
          //       id: "QW9_43_A0 m13_H g1_7B c3_D2E",
          //       name: "Foundations of Object Oriented Programming | Cheat Sheet 2",
          //       accessibleTo: ["zorvixe_core"],
          //     },
          //     {
          //       id: "QW9_44_A0 m13_H g1_7B c3_D2E",
          //       name: "MCQ Practice - Intro_OOP",
          //       accessibleTo: ["zorvixe_core"],
          //     },

          //     {
          //       id: "QW9_s45_A0 m13_H g1_7B c3_D2E",
          //       name: "Python Coding Practice 32",
          //       accessibleTo: ["zorvixe_core"],
          //     },
          //   ],
          // },
          // {
          //   id: "QW9_m50_A0 g1_H c3_7B",
          //   name: "Miscellaneous Topics",
          //   accessibleTo: ["zorvixe_core"],
          //   topic: [
          //     {
          //       id: "QW9_s51_A0 m14_H g1_7B c3_D2E",
          //       name: "Python Standard Library",
          //       accessibleTo: ["zorvixe_core"],
          //     },
          //     {
          //       id: "QW9_s52_A0 m14_H g1_7B c3_D2E",
          //       name: "Standard Library | Cheat Sheet",
          //       accessibleTo: ["zorvixe_core"],
          //     },
          //     {
          //       id: "QW9_s53_A0 m14_H g1_7B c3_D2E",
          //       name: "MCQ Practice - Standard Library",
          //       accessibleTo: ["zorvixe_core"],
          //     },

          //     {
          //       id: "QW9_s54_A0 m14_H g1_7B c3_D2E",
          //       name: "Python Coding Practice 33",
          //       accessibleTo: ["zorvixe_core"],
          //     },
          //   ],
          // },
          // //OOPS CORE END
          {
            id: "QW9_m13_A0 g1_H c3_7B",
            name: "Introduction to Object Oriented Programming",
            accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
            topic: [
              {
                id: "QW9_s1_A0 m13_H g1_7B c3_D2E",
                name: "Introduction to Object Oriented Programming",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s2_A0 m13_H g1_7B c3_D2E",
                name: "Introduction to Object Oriented Programming | Cheat Sheet",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s3_A0 m13_H g1_7B c3_D2E",
                name: "MCQ Practice - Intro_OOP",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s4_A0 m13_H g1_7B c3_D2E",
                name: "Object Oriented Programming",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s5_A0 m13_H g1_7B c3_D2E",
                name: "Object Oriented Programming | Cheat Sheet",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s6_A0 m13_H g1_7B c3_D2E",
                name: "MCQ Practice - OOP",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s7_A0 m13_H g1_7B c3_D2E",
                name: "Classes & Objects",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s8_A0 m13_H g1_7B c3_D2E",
                name: "Classes & Objects | Cheat Sheet",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s9_A0 m13_H g1_7B c3_D2E",
                name: "MCQ Practice - Classes_Obj",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s10_A0 m13_H g1_7B c3_D2E",
                name: "Coding Practice 32",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s11_A0 m13_H g1_7B c3_D2E",
                name: "Attributes and Methods",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s12_A0 m13_H g1_7B c3_D2E",
                name: "Attributes and Methods | Cheat Sheet",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s13_A0 m13_H g1_7B c3_D2E",
                name: "MCQ Practice - Att_Meth",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s14_A0 m13_H g1_7B c3_D2E",
                name: "Inheritance Part 1",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s15_A0 m13_H g1_7B c3_D2E",
                name: "Inheritance Part1 | Cheat Sheet",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s16_A0 m13_H g1_7B c3_D2E",
                name: "MCQ Practice - Inheritance1",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s17_A0 m13_H g1_7B c3_D2E",
                name: "Inheritance Part 2",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s18_A0 m13_H g1_7B c3_D2E",
                name: "Inheritance Part2 | Cheat Sheet",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s19_A0 m13_H g1_7B c3_D2E",
                name: "MCQ Practice - Inheritance2",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s20_A0 m13_H g1_7B c3_D2E",
                name: "Coding Practice 33",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s21_A0 m13_H g1_7B c3_D2E",
                name: "OOP: On Demand Session",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
            ],
          },
          {
            id: "QW9_m14_A0 g1_H c3_7B",
            name: "Miscellaneous Topics",
            accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
            topic: [
              {
                id: "QW9_s1_A0 m14_H g1_7B c3_D2E",
                name: "Python Standard Library",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s2_A0 m14_H g1_7B c3_D2E",
                name: "Python Standard Library | Cheat Sheet",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s3_A0 m14_H g1_7B c3_D2E",
                name: "MCQ Practice - PythonLibrary",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s4_A0 m14_H g1_7B c3_D2E",
                name: "Scope & Namespaces",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s5_A0 m14_H g1_7B c3_D2E",
                name: "Scope & Namespaces | Cheat Sheet",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s6_A0 m14_H g1_7B c3_D2E",
                name: "MCQ Practice - Scope_Namespaces",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s7_A0 m14_H g1_7B c3_D2E",
                name: "Errors & Exceptions",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s8_A0 m14_H g1_7B c3_D2E",
                name: "Errors & Exceptions | Cheat Sheet",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s9_A0 m14_H g1_7B c3_D2E",
                name: "MCQ Practice - Errors_Excep",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s10_A0 m14_H g1_7B c3_D2E",
                name: "Dates & Time",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s11_A0 m14_H g1_7B c3_D2E",
                name: "Dates & Time | Cheat Sheet",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s12_A0 m14_H g1_7B c3_D2E",
                name: "MCQ Practice - Dates_Time",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s13_A0 m14_H g1_7B c3_D2E",
                name: "Working with Dates & Times",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s14_A0 m14_H g1_7B c3_D2E",
                name: "Working with Dates & Times | Cheat Sheet",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s15_A0 m14_H g1_7B c3_D2E",
                name: "MCQ Practice - Working with Dates & Times",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s16_A0 m14_H g1_7B c3_D2E",
                name: "Coding Practice 34",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s17_A0 m14_H g1_7B c3_D2E",
                name: "Grand Assignment 5",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
            ],
          },
          {
            id: "QW9_m15_A0 g1_H c3_7B",
            name: "Revision",
            accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
            topic: [
              {
                id: "QW9_s1_A0 m15_H g1_7B c3_D2E",
                name: "Python Summary Cheat Sheet - 1",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s2_A0 m15_H g1_7B c3_D2E",
                name: "Python Summary Cheat Sheet - 2",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s3_A0 m15_H g1_7B c3_D2E",
                name: "Python Summary Cheat Sheet - 3",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s4_A0 m15_H g1_7B c3_D2E",
                name: "Python Summary Cheat Sheet - 4",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
            ],
          },
          {
            id: "QW9_m16_A0 g1_H c3_7B",
            name: "Programming Foundations Course Exam",
            accessibleTo: ["zorvixe_pro", "zorvixe_elite"],
            topic: [
              {
                id: "QW9_s1_A0 m16_H g1_7B c3_D2E",
                name: "Programming Foundations Course Exam | Instructions",
              },
              {
                id: "QW9_s2_A0 m16_H g1_7B c3_D2E",
                name: "Programming Foundations Course Exam",
              },
            ],
          },
        ],
      },
    ],
  },
  {
    id: "goal 2",
    title: "Goal 2",
    color: "#ff8c00",
    dateRange: "", // Will be populated dynamically
    progress: 0,
    accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
    courses: [
      {
        id: "g2 c1",
        title: "Build Your Own Dynamic Web Application: HTML, CSS, JAVASCRIPT",
        progress: 0,
        accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
        modules: [
          {
            id: "QW9_m1_A0 g2_H c1_7B",
            name: "Introduction to JS & Variables",
            accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],

            topic: [
              {
                id: "QW9_s1_A0 m1_H g2_7B c1_D2E",
                name: "Introduction to Dynamic Web Applications",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s2_A0 m1_H g2_7B c1_D2E",
                name: "Introduction to Dynamic Web Applications | Cheat Sheet",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s3_A0 m1_H g2_7B c1_D2E",
                name: "MCQ Practice - Intro_Dynamic Web App",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s4_A0 m1_H g2_7B c1_D2E",
                name: "DOM and Event Fundamentals",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s5_A0 m1_H g2_7B c1_D2E",
                name: "DOM and Event Fundamentals | Cheat Sheet",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s6_A0 m1_H g2_7B c1_D2E",
                name: "MCQ Practice - DOM Event Fund",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s7_A0 m1_H g2_7B c1_D2E",
                name: "Primitive Types & Conditionals",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s8_A0 m1_H g2_7B c1_D2E",
                name: "Primitive Types & Conditionals | Cheat Sheet",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s9_A0 m1_H g2_7B c1_D2E",
                name: "MCQ Practice - Primitive Types",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s10_A0 m1_H g2_7B c1_D2E",
                name: "Input Element and Math Functions",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s11_A0 m1_H g2_7B c1_D2E",
                name: "Input Element and Math Functions | Cheat Sheet",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s12_A0 m1_H g2_7B c1_D2E",
                name: "MCQ Practice - Input Elements",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s13_A0 m1_H g2_7B c1_D2E",
                name: "Coding Practice 1",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s14_A0 m1_H g2_7B c1_D2E",
                name: "Coding Practice 2",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s15_A0 m1_H g2_7B c1_D2E",
                name: "Coding Practice 3",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
            ],
          },
          {
            id: "QW9_m2_A0 g2_H c1_7B",
            name: "Arrays and Objects",
            accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
            topic: [
              {
                id: "QW9_s1_A0 m2_H g2_7B c1_D2E",
                name: "Arrays & More DOM Manipulations",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s2_A0 m2_H g2_7B c1_D2E",
                name: "Arrays & More DOM Manipulations | Cheat Sheet",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s3_A0 m2_H g2_7B c1_D2E",
                name: "MCQ Practice - Array & DOM",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s4_A0 m2_H g2_7B c1_D2E",
                name: "Objects",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s5_A0 m2_H g2_7B c1_D2E",
                name: "Objects | Cheat Sheet",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s6_A0 m2_H g2_7B c1_D2E",
                name: "MCQ Practice - Objects",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s7_A0 m2_H g2_7B c1_D2E",
                name: "Coding Practice 4",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s8_A0 m2_H g2_7B c1_D2E",
                name: "Coding Practice 5",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s9_A0 m2_H g2_7B c1_D2E",
                name: "Comments",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s10_A0 m2_H g2_7B c1_D2E",
                name: "JS Coding Platform Walk through",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s11_A0 m2_H g2_7B c1_D2E",
                name: "JS Coding Practice 1",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s12_A0 m2_H g2_7B c1_D2E",
                name: "JS Coding Practice 2",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s13_A0 m2_H g2_7B c1_D2E",
                name: "JS Coding Practice 3",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s14_A0 m2_H g2_7B c1_D2E",
                name: "JS Coding Practice 4",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s15_A0 m2_H g2_7B c1_D2E",
                name: "A Note On Software Compatibility",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
            ],
          },
          {
            id: "QW9_m3_A0 g2_H c1_7B",
            name: "Todos Application",
            accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
            topic: [
              {
                id: "QW9_s1_A0 m3_H g2_7B c1_D2E",
                name: "Todos Application Introduction",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s2_A0 m3_H g2_7B c1_D2E",
                name: "Todos Application | Part 1",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s3_A0 m3_H g2_7B c1_D2E",
                name: "Todos Application | Cheat Sheet",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s4_A0 m3_H g2_7B c1_D2E",
                name: "MCQ Practice - Todos App",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s5_A0 m3_H g2_7B c1_D2E",
                name: "JS Coding Practice 5",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s6_A0 m3_H g2_7B c1_D2E",
                name: "On Demand Session",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s7_A0 m3_H g2_7B c1_D2E",
                name: "On Demand Session | Cheat Sheet",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s8_A0 m3_H g2_7B c1_D2E",
                name: "MCQ Practice - On Demand Session",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s9_A0 m3_H g2_7B c1_D2E",
                name: "Todos Application | Part 2",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s10_A0 m3_H g2_7B c1_D2E",
                name: "Todos Application | Part 2 | Cheat Sheet",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s11_A0 m3_H g2_7B c1_D2E",
                name: "MCQ Practice - Todos App 2",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s12_A0 m3_H g2_7B c1_D2E",
                name: "Coding Practice 6",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s13_A0 m3_H g2_7B c1_D2E",
                name: "Coding Practice 7",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s14_A0 m3_H g2_7B c1_D2E",
                name: "Coding Practice 8",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
            ],
          },
          {
            id: "QW9_m4_A0 g2_H c1_7B",
            name: "Todos Application 2",
            accessibleTo: ["zorvixe_pro", "zorvixe_elite"],
            topic: [
              {
                id: "QW9_s1_A0 m4_H g2_7B c1_D2E",
                name: "Todos Application | Part 3",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s2_A0 m4_H g2_7B c1_D2E",
                name: "Todos Application | Part 3 | Cheat Sheet",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s3_A0 m4_H g2_7B c1_D2E",
                name: "MCQ Practice - Todos App 3",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s4_A0 m4_H g2_7B c1_D2E",
                name: "Coding Practice 9",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s5_A0 m4_H g2_7B c1_D2E",
                name: "Todos Application | Part 4",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s6_A0 m4_H g2_7B c1_D2E",
                name: "Todos Application | Part 4 | Cheat Sheet",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s7_A0 m4_H g2_7B c1_D2E",
                name: "MCQ Practice - Todos App 4",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s8_A0 m4_H g2_7B c1_D2E",
                name: "Coding Practice 10",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
            ],
          },
          {
            id: "QW9_m5_A0 g2_H c1_7B",
            name: "Todos Application 3",
            accessibleTo: ["zorvixe_pro", "zorvixe_elite"],
            topic: [
              {
                id: "QW9_s1_A0 m5_H g2_7B c1_D2E",
                name: "Todos Application | Part 5",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s2_A0 m5_H g2_7B c1_D2E",
                name: "Todos Application | Part 5 | Cheat Sheet",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s3_A0 m5_H g2_7B c1_D2E",
                name: "MCQ Practice - Todos App 5",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s4_A0 m5_H g2_7B c1_D2E",
                name: "JS Coding Practice 6",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s5_A0 m5_H g2_7B c1_D2E",
                name: "JS Coding Practice 7",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              // {
              //   id: "QW9_s6_A0 m5_H g2_7B c1_D2E",
              //   name: "Array Methods | Practice 1",
              // },
              // {
              //   id: "QW9_s7_A0 m5_H g2_7B c1_D2E",
              //   name: "Array Methods | Practice 2",
              // },
              // {
              //   id: "QW9_s8_A0 m5_H g2_7B c1_D2E",
              //   name: "Array Methods | Practice 3",
              // },
              {
                id: "QW9_s9_A0 m5_H g2_7B c1_D2E",
                name: "Coding Practice 11",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
            ],
          },
          {
            id: "QW9_m6_A0 g2_H c1_7B",
            name: "Todos Application 4",
            accessibleTo: ["zorvixe_pro", "zorvixe_elite"],
            topic: [
              {
                id: "QW9_s1_A0 m6_H g2_7B c1_D2E",
                name: "Todos Application | Part 6",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s2_A0 m6_H g2_7B c1_D2E",
                name: "Todos Application | Part 6 | Cheat Sheet",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s3_A0 m6_H g2_7B c1_D2E",
                name: "MCQ Practice - Todos App 6",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s4_A0 m6_H g2_7B c1_D2E",
                name: "Coding Practice 12",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s5_A0 m6_H g2_7B c1_D2E",
                name: "Coding Practice 13",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
            ],
          },
          {
            id: "QW9_m7_A0 g2_H c1_7B",
            name: "Fetch & Callbacks",
            accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
            topic: [
              {
                id: "QW9_s1_A0 m7_H g2_7B c1_D2E",
                name: "Callbacks & Schedulers",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s2_A0 m7_H g2_7B c1_D2E",
                name: "Callbacks & Schedulers | Cheat Sheet",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s3_A0 m7_H g2_7B c1_D2E",
                name: "MCQ Practice - Callbacks & Schedulers",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s4_A0 m7_H g2_7B c1_D2E",
                name: "Event Listeners & More Events",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s5_A0 m7_H g2_7B c1_D2E",
                name: "Event Listeners & More Events | Cheat Sheet",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s6_A0 m7_H g2_7B c1_D2E",
                name: "MCQ Practice - Event Listeners",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s7_A0 m7_H g2_7B c1_D2E",
                name: "Hypertext Transfer Protocol (HTTP)",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s8_A0 m7_H g2_7B c1_D2E",
                name: "Hypertext Transfer Protocol (HTTP) | Cheat Sheet",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s9_A0 m7_H g2_7B c1_D2E",
                name: "MCQ Practice - HTTP",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s10_A0 m7_H g2_7B c1_D2E",
                name: "Coding Practice 14",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s11_A0 m7_H g2_7B c1_D2E",
                name: "Coding Practice 15",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s12_A0 m7_H g2_7B c1_D2E",
                name: "Coding Assignment 1",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
            ],
          },
          {
            id: "QW9_m8_A0 g2_H c1_7B",
            name: "Fetch & Callbacks 2",
            accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
            topic: [
              {
                id: "QW9_s1_A0 m8_H g2_7B c1_D2E",
                name: "HTTP Requests using JS",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s2_A0 m8_H g2_7B c1_D2E",
                name: "HTTP Requests using JS | Cheat Sheet",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s3_A0 m8_H g2_7B c1_D2E",
                name: "MCQ Practice - HTTP Requests using JS",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s4_A0 m8_H g2_7B c1_D2E",
                name: "Wikipedia Search Application",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s5_A0 m8_H g2_7B c1_D2E",
                name: "Wikipedia Search Application | Cheat Sheet",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s6_A0 m8_H g2_7B c1_D2E",
                name: "MCQ Practice - Wikipedia Application",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s7_A0 m8_H g2_7B c1_D2E",
                name: "Coding Practice 16",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s8_A0 m8_H g2_7B c1_D2E",
                name: "Coding Practice 17",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s9_A0 m8_H g2_7B c1_D2E",
                name: "Coding Practice 18",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
            ],
          },
          {
            id: "QW9_m9_A0 g2_H c1_7B",
            name: "Forms",
            accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
            topic: [
              {
                id: "QW9_s1_A0 m9_H g2_7B c1_D2E",
                name: "Forms",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s2_A0 m9_H g2_7B c1_D2E",
                name: "Forms | Cheat sheet",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s3_A0 m9_H g2_7B c1_D2E",
                name: "MCQ Practice - Forms",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s4_A0 m9_H g2_7B c1_D2E",
                name: "Forms | Part 2",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s5_A0 m9_H g2_7B c1_D2E",
                name: "Forms | Part 2 | Cheat sheet",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s6_A0 m9_H g2_7B c1_D2E",
                name: "MCQ Practice - Forms Part 2",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s7_A0 m9_H g2_7B c1_D2E",
                name: "Coding Practice 19",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s8_A0 m9_H g2_7B c1_D2E",
                name: "Coding Practice 20",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
            ],
          },
          {
            id: "QW9_m10_A0 g2_H c1_7B",
            name: "Assignment",
            accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
            topic: [
              {
                id: "QW9_s1_A0 m10_H g2_7B c1_D2E",
                name: "MCQ Assignment 1",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s2_A0 m10_H g2_7B c1_D2E",
                name: "MCQ Assignment 2",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s3_A0 m10_H g2_7B c1_D2E",
                name: "MCQ Assignment 3",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s4_A0 m10_H g2_7B c1_D2E",
                name: "MCQ Assignment 4",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s5_A0 m10_H g2_7B c1_D2E",
                name: "Coding Assignment 2",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s6_A0 m10_H g2_7B c1_D2E",
                name: "Coding Assignment 3",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
            ],
          },
          {
            id: "QW9_m11_A0 g2_H c1_7B",
            name: "Mock Test",
            accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
            topic: [
              {
                id: "QW9_s1_A0 m11_H g2_7B c1_D2E",
                name: "Coding Test 1",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s2_A0 m11_H g2_7B c1_D2E",
                name: "Coding Test 2",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s3_A0 m11_H g2_7B c1_D2E",
                name: "Coding Test 3",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s4_A0 m11_H g2_7B c1_D2E",
                name: "Coding Test 4",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s5_A0 m11_H g2_7B c1_D2E",
                name: "JS Coding Test 1",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s6_A0 m11_H g2_7B c1_D2E",
                name: "JS MCQ Test 1",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s7_A0 m11_H g2_7B c1_D2E",
                name: "JS Coding Test 2",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s8_A0 m11_H g2_7B c1_D2E",
                name: "JS MCQ Test 2",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
            ],
          },
          {
            id: "QW9_m12_A0 g2_H c1_7B",
            name: "Build Your Own Dynamic Web Application Course Exam",
            accessibleTo: [],
            topic: [
              {
                id: "QW9_s1_A0 m12_H g2_7B c1_D2E",
                name: "Build Your Own Dynamic Web Application Course Exam | Instructions",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s2_A0 m12_H g2_7B c1_D2E",
                name: "Build Your Own Dynamic Web Application Course Exam",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
            ],
          },
        ],
      },
      {
        id: "g2 c2",
        title: "Introduction to Databases: SQL",
        progress: 0,
        accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
        modules: [
          {
            id: "QW9_m1_A0 g2_H c2_7B",
            name: "Introduction",
            accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],

            topic: [
              {
                id: "QW9_s1_A0 m1_H g2_7B c2_D2E",
                name: "Introduction to Databases | Part 1",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s2_A0 m1_H g2_7B c2_D2E",
                name: "Introduction to Databases | Part 2",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s3_A0 m1_H g2_7B c2_D2E",
                name: "Introduction to Databases | Cheat Sheet",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s4_A0 m1_H g2_7B c2_D2E",
                name: "MCQ Practice Introduction to Databases",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
            ],
          },
          {
            id: "QW9_m2_A0 g2_H c2_7B",
            name: "Introduction to SQL",
            accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
            topic: [
              {
                id: "QW9_s1_A0 m2_H g2_7B c2_D2E",
                name: "Introduction to SQL | Part 1",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s2_A0 m2_H g2_7B c2_D2E",
                name: "Introduction to SQL | Part 2",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s3_A0 m2_H g2_7B c2_D2E",
                name: "Platform Walkthrough",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s4_A0 m2_H g2_7B c2_D2E",
                name: "Create Table Cheat Sheet",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s5_A0 m2_H g2_7B c2_D2E",
                name: "Inserting Rows Cheat Sheet",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s6_A0 m2_H g2_7B c2_D2E",
                name: "Retrieving Data Cheat Sheet",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s7_A0 m2_H g2_7B c2_D2E",
                name: "Update Rows Cheat Sheet",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s8_A0 m2_H g2_7B c2_D2E",
                name: "Delete Rows Cheat Sheet",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s9_A0 m2_H g2_7B c2_D2E",
                name: "Alter Table Cheat Sheet",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s10_A0 m2_H g2_7B c2_D2E",
                name: "MCQ Practice - Introduction to SQL | Part 1",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s11_A0 m2_H g2_7B c2_D2E",
                name: "MCQ Practice - Introduction to SQL | Part 2",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s12_A0 m2_H g2_7B c2_D2E",
                name: "Common Mistakes | Reading Material",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s13_A0 m2_H g2_7B c2_D2E",
                name: "MCQ Practice - Common Mistakes | Reading Material",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s14_A0 m2_H g2_7B c2_D2E",
                name: "SQL Coding Practice 1",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s15_A0 m2_H g2_7B c2_D2E",
                name: "SQL Coding Practice 2",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
            ],
          },
          {
            id: "QW9_m3_A0 g2_H c2_7B",
            name: "Querying with SQL",
            accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
            topic: [
              {
                id: "QW9_s1_A0 m3_H g2_7B c2_D2E",
                name: "Querying with SQL | Part 1",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s2_A0 m3_H g2_7B c2_D2E",
                name: "Comparison Operators Cheat Sheet",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s3_A0 m3_H g2_7B c2_D2E",
                name: "String Operations Cheat Sheet",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s4_A0 m3_H g2_7B c2_D2E",
                name: "MCQ Practice Querying with SQL | Part 1",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s5_A0 m3_H g2_7B c2_D2E",
                name: "SQL Coding Practice 3",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s6_A0 m3_H g2_7B c2_D2E",
                name: "Querying with SQL | Part 2",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s7_A0 m3_H g2_7B c2_D2E",
                name: "Logical Operators Cheat sheet",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s8_A0 m3_H g2_7B c2_D2E",
                name: "MCQ Practice Querying with SQL | Part 2",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s9_A0 m3_H g2_7B c2_D2E",
                name: "SQL Coding Practice 4",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s10_A0 m3_H g2_7B c2_D2E",
                name: "Querying with SQL | Part 3",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s11_A0 m3_H g2_7B c2_D2E",
                name: "In and Between Operators Cheat Sheet",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s12_A0 m3_H g2_7B c2_D2E",
                name: "Order By Distinct Cheat Sheet",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s13_A0 m3_H g2_7B c2_D2E",
                name: "Pagination Cheat Sheet",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s14_A0 m3_H g2_7B c2_D2E",
                name: "MCQ Practice Querying with SQL | Part 3",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s15_A0 m3_H g2_7B c2_D2E",
                name: "SQL Coding Practice 5",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
            ],
          },
          {
            id: "QW9_m4_A0 g2_H c2_7B",
            name: "Aggregations and Group By",
            accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
            topic: [
              {
                id: "QW9_s1_A0 m4_H g2_7B c2_D2E",
                name: "Aggregations",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s2_A0 m4_H g2_7B c2_D2E",
                name: "Aggregations | Cheat Sheet",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s3_A0 m4_H g2_7B c2_D2E",
                name: "MCQ Practice - Aggregations",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s4_A0 m4_H g2_7B c2_D2E",
                name: "Group By",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s5_A0 m4_H g2_7B c2_D2E",
                name: "Group By with Having",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s6_A0 m4_H g2_7B c2_D2E",
                name: "Group By with Having | Cheat Sheet",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s7_A0 m4_H g2_7B c2_D2E",
                name: "MCQ Pratice - Group By with Having",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s8_A0 m4_H g2_7B c2_D2E",
                name: "SQL Coding Practice 6",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
            ],
          },
          {
            id: "QW9_m5_A0 g2_H c2_7B",
            name: "Common Concepts",
            accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
            topic: [
              {
                id: "QW9_s1_A0 m4_H g2_7B c2_D2E",
                name: "Common Concepts",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s2_A0 m4_H g2_7B c2_D2E",
                name: "SQL Expression | Cheat Sheet",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s3_A0 m4_H g2_7B c2_D2E",
                name: "SQL Functions | Cheat Sheet",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s4_A0 m4_H g2_7B c2_D2E",
                name: "Cast Functions | Cheat Sheet",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s5_A0 m5_H g2_7B c2_D2E",
                name: "Arthmetic Functions | Cheat Cheet",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s6_A0 m5_H g2_7B c2_D2E",
                name: "SQL Case | Cheat Sheet",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s7_A0 m5_H g2_7B c2_D2E",
                name: "SQL Set Operations | Cheat Sheet",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s8_A0 m5_H g2_7B c2_D2E",
                name: "MCQ Practice Common Concepts",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s9_A0 m5_H g2_7B c2_D2E",
                name: "SQL Coding Practice 7",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
            ],
          },
          {
            id: "QW9_m6_A0 g2_H c2_7B",
            name: "MileStone",
            accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
            topic: [
              {
                id: "QW9_s1_A0 m6_H g2_7B c2_D2E",
                name: "MileStone | Cheat Sheet",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s2_A0 m6_H g2_7B c2_D2E",
                name: "MCQ Practice MileStone",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s3_A0 m6_H g2_7B c2_D2E",
                name: "SQL Assignment 1",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s4_A0 m6_H g2_7B c2_D2E",
                name: "SQL Assignment 2",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
            ],
          },
          {
            id: "QW9_m7_A0 g2_H c2_7B",
            name: "Modelling Databases",
            accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
            topic: [
              {
                id: "QW9_s1_A0 m7_H g2_7B c2_D2E",
                name: "Modelling Database | Part 1",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s2_A0 m7_H g2_7B c2_D2E",
                name: "Core Concepts of ER Model | Cheat Sheets",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s3_A0 m7_H g2_7B c2_D2E",
                name: "Appliying ER Model Concepts | Cheat Sheets",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s4_A0 m7_H g2_7B c2_D2E",
                name: "ER Model to Relational Database | Cheat Sheets",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s5_A0 m7_H g2_7B c2_D2E",
                name: "MCQ Practice Modelling Database | Part 1",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s6_A0 m7_H g2_7B c2_D2E",
                name: "Modelling Database | Part 2",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s7_A0 m7_H g2_7B c2_D2E",
                name: "Createing a Relational Database | Cheat Sheets",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s8_A0 m7_H g2_7B c2_D2E",
                name: "MCQ Practice Modelling Database | Part 2",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s9_A0 m7_H g2_7B c2_D2E",
                name: "SQL Coding Practice 8",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
            ],
          },
          {
            id: "QW9_m8_A0 g2_H c2_7B",
            name: "Joins",
            accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
            topic: [
              {
                id: "QW9_s1_A0 m8_H g2_7B c2_D2E",
                name: "Joins | Part 1",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s2_A0 m8_H g2_7B c2_D2E",
                name: "Joins | Part 1 | Cheat Sheet",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s3_A0 m8_H g2_7B c2_D2E",
                name: "MCQ Practice Joins",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s4_A0 m8_H g2_7B c2_D2E",
                name: "SQL Coding Practice 9",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s5_A0 m8_H g2_7B c2_D2E",
                name: "Querying with Joins | Part 2",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s6_A0 m8_H g2_7B c2_D2E",
                name: "Querying with Joins | Part 2 | Cheat Sheet",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s7_A0 m8_H g2_7B c2_D2E",
                name: "MCQ Practice Querying with Joins | Part 2",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s8_A0 m8_H g2_7B c2_D2E",
                name: "SQL Coding Practice 10",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s9_A0 m8_H g2_7B c2_D2E",
                name: "Querying with Joins | Part 3",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s10_A0 m8_H g2_7B c2_D2E",
                name: "Querying with Joins | Part 3 | Cheat Sheet",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s11_A0 m8_H g2_7B c2_D2E",
                name: "MCQ Practice Querying with Joins | Part 3",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s12_A0 m8_H g2_7B c2_D2E",
                name: "SQL Coding Practice 11",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s13_A0 m8_H g2_7B c2_D2E",
                name: "SQL Coding Practice 12",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
            ],
          },
          {
            id: "QW9_m9_A0 g2_H c2_7B",
            name: "Views and Subqueries",
            accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
            topic: [
              {
                id: "QW9_s1_A0 m9_H g2_7B c2_D2E",
                name: "Views and Subqueries",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s2_A0 m9_H g2_7B c2_D2E",
                name: "Views Subqueries | Cheat Sheet",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s3_A0 m9_H g2_7B c2_D2E",
                name: "Subqueries | Cheat Sheet",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s4_A0 m9_H g2_7B c2_D2E",
                name: "MCQ Practice Views and Subqueries",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s5_A0 m9_H g2_7B c2_D2E",
                name: "SQL Coding Practice 13",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
            ],
          },
          {
            id: "QW9_m10_A0 g2_H c2_7B",
            name: "Transaction and Indexes",
            accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
            topic: [
              {
                id: "QW9_s1_A0 m10_H g2_7B c2_D2E",
                name: "Transaction and Indexes",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s2_A0 m10_H g2_7B c2_D2E",
                name: "Transaction and Indexes | Cheat Sheet",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s3_A0 m10_H g2_7B c2_D2E",
                name: "MCQ Practice Transaction and Indexes",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
            ],
          },
          {
            id: "QW9_m11_A0 g2_H c2_7B",
            name: "SQL Syntax Differences Between SQLite, MySQL, and Oracle",
            accessibleTo: ["zorvixe_pro", "zorvixe_elite"],
            topic: [
              {
                id: "QW9_s1_A0 m11_H g2_7B c2_D2E",
                name: "SQL Syntax Differences Between SQLite, MySQL, and Oracle",
              },
            ],
          },
          {
            id: "QW9_m12_A0 g2_H c2_7B",
            name: "MileStone 2",
            accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
            topic: [
              {
                id: "QW9_s1_A0 m12_H g2_7B c2_D2E",
                name: "SQL Assignment 3",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s2_A0 m12_H g2_7B c2_D2E",
                name: "MCQ Exam 1",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
            ],
          },
          {
            id: "QW9_m13_A0 g2_H c2_7B",
            name: "Introduction to Databases Course Exam",
            accessibleTo: [],
            topic: [
              {
                id: "QW9_s1_A0 m13_H g2_7B c2_D2E",
                name: "Introduction to Databases Course Exam | Instructions",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s2_A0 m13_H g2_7B c2_D2E",
                name: "Introduction to Databases Course Exam",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
            ],
          },
        ],
      },
      {
        id: "g2 c3",
        title: "JavaScript Essentials: JAVASCRIPT",
        progress: 0,
        accessibleTo: ["zorvixe_pro", "zorvixe_elite"],
        modules: [
          {
            id: "QW9_m1_A0 g2_H c3_7B",
            name: "More Modern JS Concepts",
            accessibleTo: ["zorvixe_pro", "zorvixe_elite"],

            topic: [
              {
                id: "QW9_s1_A0 m1_H g2_7B c3_D2E",
                name: "More Modern JS Concepts",
                accessibleTo: ["zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s2_A0 m1_H g2_7B c3_D2E",
                name: "More Modern JS Concepts | Cheat Sheet",
                accessibleTo: ["zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s3_A0 m1_H g2_7B c3_D2E",
                name: "MCQ Practice - More Modern JS Concepts",
                accessibleTo: ["zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s4_A0 m1_H g2_7B c3_D2E",
                name: "More Modern JS Concepts | Part 2",
                accessibleTo: ["zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s5_A0 m1_H g2_7B c3_D2E",
                name: "More Modern JS Concepts | Part 2 | Cheat Sheet",
                accessibleTo: ["zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s6_A0 m1_H g2_7B c3_D2E",
                name: "MCQ Practice - More Modern JS Concepts | Part 2",
                accessibleTo: ["zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s7_A0 m1_H g2_7B c3_D2E",
                name: "Factory and Constructor Function",
                accessibleTo: ["zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s8_A0 m1_H g2_7B c3_D2E",
                name: "Factory and Constructor Function | Cheat Sheet",
                accessibleTo: ["zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s9_A0 m1_H g2_7B c3_D2E",
                name: "MCQ Practice - Factory and Constructor Function",
                accessibleTo: ["zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s10_A0 m1_H g2_7B c3_D2E",
                name: "JS Coding Practice 1",
                accessibleTo: ["zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s11_A0 m1_H g2_7B c3_D2E",
                name: "JS Coding Practice 2",
                accessibleTo: ["zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s12_A0 m1_H g2_7B c3_D2E",
                name: "JS Coding Practice 3",
                accessibleTo: ["zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s13_A0 m1_H g2_7B c3_D2E",
                name: "More Modern JS Concepts | Part 3",
                accessibleTo: ["zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s14_A0 m1_H g2_7B c3_D2E",
                name: "More Modern JS Concepts | Part 3 | Cheat Sheet",
                accessibleTo: ["zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s15_A0 m1_H g2_7B c3_D2E",
                name: "MCQ Practice - More Modern JS Concepts | Part 3",
                accessibleTo: ["zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s16_A0 m1_H g2_7B c3_D2E",
                name: "JS Coding Practice 4",
                accessibleTo: ["zorvixe_pro", "zorvixe_elite"],
              },
            ],
          },
          {
            id: "QW9_m2_A0 g2_H c3_7B",
            name: "Prototypes and Classes",
            accessibleTo: ["zorvixe_pro", "zorvixe_elite"],
            topic: [
              {
                id: "QW9_s1_A0 m2_H g2_7B c3_D2E",
                name: "Prototypal Inheritance",
                accessibleTo: ["zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s2_A0 m2_H g2_7B c3_D2E",
                name: "Prototypal Inheritance | Cheat Sheet",
                accessibleTo: ["zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s3_A0 m2_H g2_7B c3_D2E",
                name: "MCQ Practice - Prototypal Inheritance",
                accessibleTo: ["zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s4_A0 m2_H g2_7B c3_D2E",
                name: "JS Classes",
                accessibleTo: ["zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s5_A0 m2_H g2_7B c3_D2E",
                name: "JS Classes | Cheat Sheet",
                accessibleTo: ["zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s6_A0 m2_H g2_7B c3_D2E",
                name: "MCQ Practice - JS Classes",
                accessibleTo: ["zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s7_A0 m2_H g2_7B c3_D2E",
                name: "JS Coding Practice 5",
                accessibleTo: ["zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s8_A0 m2_H g2_7B c3_D2E",
                name: "JS Coding Practice 6",
                accessibleTo: ["zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s9_A0 m2_H g2_7B c3_D2E",
                name: "JS Coding Practice 7",
                accessibleTo: ["zorvixe_pro", "zorvixe_elite"],
              },
            ],
          },
          {
            id: "QW9_m3_A0 g2_H c3_7B",
            name: "Promises and Array Methods",
            accessibleTo: ["zorvixe_pro", "zorvixe_elite"],
            topic: [
              {
                id: "QW9_s1_A0 m3_H g2_7B c3_D2E",
                name: "JS Promises",
                accessibleTo: ["zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s2_A0 m3_H g2_7B c3_D2E",
                name: "JS Promises | Cheat Sheet",
                accessibleTo: ["zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s3_A0 m3_H g2_7B c3_D2E",
                name: "MCQ Practice - JS Promises",
                accessibleTo: ["zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s4_A0 m3_H g2_7B c3_D2E",
                name: "JS Promises 2",
                accessibleTo: ["zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s5_A0 m3_H g2_7B c3_D2E",
                name: "JS Promises | Part 2 | Cheat Sheet",
                accessibleTo: ["zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s6_A0 m3_H g2_7B c3_D2E",
                name: "MCQ Practice - JS Promises | Part 2",
                accessibleTo: ["zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s7_A0 m3_H g2_7B c3_D2E",
                name: "JS Coding Practice 8",
                accessibleTo: ["zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s8_A0 m3_H g2_7B c3_D2E",
                name: "JS Coding Practice 9",
                accessibleTo: ["zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s9_A0 m3_H g2_7B c3_D2E",
                name: "More JS Concepts",
                accessibleTo: ["zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s10_A0 m3_H g2_7B c3_D2E",
                name: "More JS Concepts | Cheat Sheet",
                accessibleTo: ["zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s11_A0 m3_H g2_7B c3_D2E",
                name: "MCQ Practice - More JS Concepts",
                accessibleTo: ["zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s12_A0 m3_H g2_7B c3_D2E",
                name: "Clean Code Guidelines",
                accessibleTo: ["zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s13_A0 m3_H g2_7B c3_D2E",
                name: "JS Coding Practice 10",
                accessibleTo: ["zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s14_A0 m3_H g2_7B c3_D2E",
                name: "JS Coding Practice 11",
                accessibleTo: ["zorvixe_pro", "zorvixe_elite"],
              },
            ],
          },
          {
            id: "QW9_m4_A0 g2_H c3_7B",
            name: "Assignments",
            accessibleTo: ["zorvixe_pro", "zorvixe_elite"],
            topic: [
              {
                id: "QW9_s1_A0 m4_H g2_7B c3_D2E",
                name: "JS Essentials MCQ Assignment 1",
                accessibleTo: ["zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s2_A0 m4_H g2_7B c3_D2E",
                name: "JS Essentials MCQ Assignment 2",
                accessibleTo: ["zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s3_A0 m4_H g2_7B c3_D2E",
                name: "JS Essentials MCQ Assignment 3",
                accessibleTo: ["zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s4_A0 m4_H g2_7B c3_D2E",
                name: "JS Essentials MCQ Assignment 4",
                accessibleTo: ["zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s5_A0 m4_H g2_7B c3_D2E",
                name: "JS Coding Assignment 1",
                accessibleTo: ["zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s6_A0 m4_H g2_7B c3_D2E",
                name: "JS Coding Assignment 2",
                accessibleTo: ["zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s7_A0 m4_H g2_7B c3_D2E",
                name: "JS Coding Assignment 3",
                accessibleTo: ["zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s8_A0 m4_H g2_7B c3_D2E",
                name: "JS Coding Assignment 4",
                accessibleTo: ["zorvixe_pro", "zorvixe_elite"],
              },
            ],
          },
          {
            id: "QW9_m5_A0 g2_H c3_7B",
            name: "Mock Tests",
            accessibleTo: ["zorvixe_pro", "zorvixe_elite"],
            topic: [
              {
                id: "QW9_s1_A0 m5_H g2_7B c3_D2E",
                name: "JS Essentials Mock Test 1",
                accessibleTo: ["zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s2_A0 m5_H g2_7B c3_D2E",
                name: "JS Coding Test 1",
                accessibleTo: ["zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s3_A0 m5_H g2_7B c3_D2E",
                name: "JS Essentials Mock Test 2",
                accessibleTo: ["zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s4_A0 m5_H g2_7B c3_D2E",
                name: "JS Coding Test 2",
                accessibleTo: ["zorvixe_pro", "zorvixe_elite"],
              },
            ],
          },
          {
            id: "QW9_m6_A0 g2_H c3_7B",
            name: "JavaScript Essentials Course Exam",
            accessibleTo: ["zorvixe_pro", "zorvixe_elite"],
            topic: [
              {
                id: "QW9_s1_A0 m6_H g2_7B c3_D2E",
                name: "JavaScript Essentials Course Exam | Cheat Sheet",
                accessibleTo: ["zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s2_A0 m6_H g2_7B c3_D2E",
                name: "JavaScript Essentials Course Exam",
                accessibleTo: ["zorvixe_pro", "zorvixe_elite"],
              },
            ],
          },
        ],
      },
      {
        id: "g2 c4",
        title: "Responsive Web Design using Flexbox: FLEXBOX",
        progress: 0,
        accessibleTo: ["zorvixe_pro", "zorvixe_elite"],
        modules: [
          {
            id: "QW9_m1_A0 g2_H c4_7B",
            name: "Flexbox",
            accessibleTo: ["zorvixe_pro", "zorvixe_elite"],
            topic: [
              {
                id: "QW9_s1_A0 m1_H g2_7B c4_D2E",
                name: "Sizing Elements and Handling Overflow",
                accessibleTo: ["zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s2_A0 m1_H g2_7B c4_D2E",
                name: "Sizing Elements and Handling Overflow | Cheat Sheet",
                accessibleTo: ["zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s3_A0 m1_H g2_7B c4_D2E",
                name: "MCQ Pratice - Sizing Elements and Handling Overflow",
                accessibleTo: ["zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s4_A0 m1_H g2_7B c4_D2E",
                name: "Coding Pratice - 1 - Sizing Elements and Handling Overflow",
                accessibleTo: ["zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s5_A0 m1_H g2_7B c4_D2E",
                name: "Box Sizing",
                accessibleTo: ["zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s6_A0 m1_H g2_7B c4_D2E",
                name: "Box Sizing | Cheat Sheet",
                accessibleTo: ["zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s7_A0 m1_H g2_7B c4_D2E",
                name: "MCQ Pratice - Box Sizing",
                accessibleTo: ["zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s8_A0 m1_H g2_7B c4_D2E",
                name: "Coding Pratice - 2 - Box Sizing",
                accessibleTo: ["zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s9_A0 m1_H g2_7B c4_D2E",
                name: "Introduction to CSS Flexbox",
                accessibleTo: ["zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s10_A0 m1_H g2_7B c4_D2E",
                name: "Introduction to CSS Flexbox | Cheat Sheet",
                accessibleTo: ["zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s11_A0 m1_H g2_7B c4_D2E",
                name: "MCQ Pratice - CSS Flexbox 1",
                accessibleTo: ["zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s12_A0 m1_H g2_7B c4_D2E",
                name: "Coding Pratice 3 - CSS Flexbox",
                accessibleTo: ["zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s13_A0 m1_H g2_7B c4_D2E",
                name: "Introduction to CSS Flexbox | Part 2",
                accessibleTo: ["zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s14_A0 m1_H g2_7B c4_D2E",
                name: "Introduction to CSS Flexbox | Part 2| Cheat Sheet",
                accessibleTo: ["zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s15_A0 m1_H g2_7B c4_D2E",
                name: "MCQ Pratice - CSS Flexbox 2",
                accessibleTo: ["zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s16_A0 m1_H g2_7B c4_D2E",
                name: "Coding Pratice 4 - CSS Flexbox",
                accessibleTo: ["zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s17_A0 m1_H g2_7B c4_D2E",
                name: "Introduction to CSS Flexbox | Part 3",
                accessibleTo: ["zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s18_A0 m1_H g2_7B c4_D2E",
                name: "Introduction to CSS Flexbox | Part 3| Cheat Sheet",
                accessibleTo: ["zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s19_A0 m1_H g2_7B c4_D2E",
                name: "MCQ Pratice - CSS Flexbox 3",
                accessibleTo: ["zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s20_A0 m1_H g2_7B c4_D2E",
                name: "Coding Pratice 5 - CSS Flexbox",
                accessibleTo: ["zorvixe_pro", "zorvixe_elite"],
              },
            ],
          },
          {
            id: "QW9_m2_A0 g2_H c4_7B",
            name: "CSS Media Queries",
            accessibleTo: ["zorvixe_pro", "zorvixe_elite"],
            topic: [
              {
                id: "QW9_s1_A0 m1_H g2_7B c4_D2E",
                name: "CSS Media Queries",
                accessibleTo: ["zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s2_A0 m1_H g2_7B c4_D2E",
                name: "CSS Media Queries | Cheat Sheet",
                accessibleTo: ["zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s3_A0 m1_H g2_7B c4_D2E",
                name: "MCQ Pratice - CSS Media Queries",
                accessibleTo: ["zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s4_A0 m1_H g2_7B c4_D2E",
                name: "Coding Pratice 6 - CSS Media Queries",
                accessibleTo: ["zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s5_A0 m1_H g2_7B c4_D2E",
                name: "Coding Pratice 2 - CSS Media Queries",
                accessibleTo: ["zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s6_A0 m1_H g2_7B c4_D2E",
                name: "Flexbox Sizing",
                accessibleTo: ["zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s2_A0 m1_H g2_7B c4_D2E",
                name: "Flexbox Sizing | Cheat Sheet",
                accessibleTo: ["zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s3_A0 m1_H g2_7B c4_D2E",
                name: "MCQ Pratice - Flexbox Sizing",
                accessibleTo: ["zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s4_A0 m1_H g2_7B c4_D2E",
                name: "Coding Pratice 7 - Flexbox Sizing",
                accessibleTo: ["zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s6_A0 m1_H g2_7B c4_D2E",
                name: "On Demand Session",
                accessibleTo: ["zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s2_A0 m1_H g2_7B c4_D2E",
                name: "On Demand Session | Cheat Sheet",
                accessibleTo: ["zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s3_A0 m1_H g2_7B c4_D2E",
                name: "MCQ Pratice - On Demand Session",
                accessibleTo: ["zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s4_A0 m1_H g2_7B c4_D2E",
                name: "Coding Pratice 8 - On Demand Session",
                accessibleTo: ["zorvixe_pro", "zorvixe_elite"],
              },
            ],
          },
          {
            id: "QW9_m3_A0 g2_H c4_7B",
            name: "Assignments",
            accessibleTo: ["zorvixe_pro", "zorvixe_elite"],
            topic: [
              {
                id: "QW9_s1_A0 m1_H g2_7B c4_D2E",
                name: "MCQ Assignment 1",
                accessibleTo: ["zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s2_A0 m1_H g2_7B c4_D2E",
                name: "MCQ Assignment 2",
                accessibleTo: ["zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s3_A0 m1_H g2_7B c4_D2E",
                name: "MCQ Assignment 3",
                accessibleTo: ["zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s4_A0 m1_H g2_7B c4_D2E",
                name: "MCQ Assignment 4",
                accessibleTo: ["zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s5_A0 m1_H g2_7B c4_D2E",
                name: "Coding Assignment 1",
                accessibleTo: ["zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s6_A0 m1_H g2_7B c4_D2E",
                name: "Coding Assignment 2",
                accessibleTo: ["zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s7_A0 m1_H g2_7B c4_D2E",
                name: "Coding Assignment 3",
                accessibleTo: ["zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s4_A0 m1_H g2_7B c4_D2E",
                name: "Coding Assignment 4",
                accessibleTo: ["zorvixe_pro", "zorvixe_elite"],
              },
            ],
          },
          {
            id: "QW9_m4_A0 g2_H c4_7B",
            name: "Mock Tests",
            accessibleTo: ["zorvixe_pro", "zorvixe_elite"],
            topic: [
              {
                id: "QW9_s1_A0 m1_H g2_7B c4_D2E",
                name: "MCQ Test 1",
                accessibleTo: ["zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s2_A0 m1_H g2_7B c4_D2E",
                name: "Coding Test 1",
                accessibleTo: ["zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s3_A0 m1_H g2_7B c4_D2E",
                name: "MCQ Test 1",
                accessibleTo: ["zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s4_A0 m1_H g2_7B c4_D2E",
                name: "Coding Test 2",
                accessibleTo: ["zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s5_A0 m1_H g2_7B c4_D2E",
                name: "Coding Test 3",
                accessibleTo: ["zorvixe_pro", "zorvixe_elite"],
              },
            ],
          },
          {
            id: "QW9_m5_A0 g2_H c4_7B",
            name: "Responsive Web Design Using Flexbox Course Exam",
            accessibleTo: ["zorvixe_pro", "zorvixe_elite"],
            topic: [
              {
                id: "QW9_s1_A0 m1_H g2_7B c4_D2E",
                name: "Responsive Web Design Using Flexbox Course Exam | Instruction",
                accessibleTo: ["zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s2_A0 m1_H g2_7B c4_D2E",
                name: "Responsive Web Design Using Flexbox Course Exam",
                accessibleTo: ["zorvixe_pro", "zorvixe_elite"],
              },
            ],
          },
        ],
      },
    ],
  },
  {
    id: "goal 3",
    title: "Goal 3",
    color: "#28a745",
    dateRange: "", // Will be populated dynamically
    progress: 0,
    accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
    courses: [
      {
        id: "g3 c1",
        title: " Developer Foundations: Git, Commandline",
        progress: 0,
        accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
        modules: [
          {
            id: "QW9_m1_A0 g3_H c1_7B",
            name: "Git",
            accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
            topic: [
              {
                id: "QW9_s1_A0 m1_H g3_7B c1_D2E",
                name: "Commandline",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
            ],
          },
        ],
      },
      {
        id: "g3 c2",
        title: "Node JS: Node JS",
        progress: 0,
        accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
        modules: [
          {
            id: "QW9_m1_A0 g3_H c2_7B",
            name: "MERN Stack",
            accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
            topic: [
              {
                id: "QW9_s1_A0 m1_H g3_7B c2_D2E",
                name: "MERN Stack",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
            ],
          },
          {
            id: "QW9_m2_A0 g3_H c2_7B",
            name: "Introduction to Node JS",
            accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
            topic: [
              {
                id: "QW9_s1_A0 m2_H g3_7B c2_D2E",
                name: "Introduction to Node JS",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s2_A0 m2_H g3_7B c2_D2E",
                name: "Introduction to Node JS | Cheat Sheet",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s3_A0 m2_H g3_7B c2_D2E",
                name: "MCQ Pratice - Introduction to Node JS",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s4_A0 m2_H g3_7B c2_D2E",
                name: "Common JS Module Exports | Reading Material",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s5_A0 m2_H g3_7B c2_D2E",
                name: "MCQ Pratice - Common JS Module Exports",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s6_A0 m2_H g3_7B c2_D2E",
                name: "ES6 Module Exports | Reading Material",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s7_A0 m2_H g3_7B c2_D2E",
                name: "MCQ Pratice - ES6 Module Exports",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s8_A0 m2_H g3_7B c2_D2E",
                name: "Coding Pratice 1 - Node JS",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s9_A0 m2_H g3_7B c2_D2E",
                name: "Introduction to Node JS | Part 2",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s10_A0 m2_H g3_7B c2_D2E",
                name: "Introduction to Node JS | Part 2 | Cheat Sheet",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s11_A0 m2_H g3_7B c2_D2E",
                name: "MCQ Pratice - Introduction to Node JS | Part 2",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s12_A0 m2_H g3_7B c2_D2E",
                name: "Coding Pratice 2 - Node JS",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
            ],
          },
          {
            id: "QW9_m3_A0 g3_H c2_7B",
            name: "Introduction to Express JS",
            accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
            topic: [
              {
                id: "QW9_s1_A0 m3_H g3_7B c2_D2E",
                name: "Hypertext Transfer Protocol (HTTP)",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s2_A0 m3_H g3_7B c2_D2E",
                name: "Introduction to Express JS",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s3_A0 m3_H g3_7B c2_D2E",
                name: "Introduction to Express JS | Cheat Sheet",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s4_A0 m3_H g3_7B c2_D2E",
                name: "MCQ Pratice - Introduction to Express JS",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s5_A0 m3_H g3_7B c2_D2E",
                name: "Coding Pratice 3 - Node JS",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s6_A0 m3_H g3_7B c2_D2E",
                name: "Introduction to Express JS | Part 2",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s7_A0 m3_H g3_7B c2_D2E",
                name: "Introduction to Express JS | Part 2 | Cheat Sheet",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s8_A0 m3_H g3_7B c2_D2E",
                name: "MCQ Pratice - Introduction to Express JS | Part 2",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s9_A0 m3_H g3_7B c2_D2E",
                name: "Introduction to Express JS | Part 3",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s10_A0 m3_H g3_7B c2_D2E",
                name: "Introduction to Express JS | Part 3 | Cheat Sheet",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s11_A0 m3_H g3_7B c2_D2E",
                name: "MCQ Pratice - Introduction to Express JS | Part 3",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s12_A0 m3_H g3_7B c2_D2E",
                name: "Coding Pratice 4 - Node JS",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s13_A0 m3_H g3_7B c2_D2E",
                name: "Coding Pratice 5 - Node JS",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s14_A0 m3_H g3_7B c2_D2E",
                name: "Coding Pratice 6 - Node JS",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s15_A0 m3_H g3_7B c2_D2E",
                name: "Coding Pratice 7 - Node JS",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
            ],
          },
          {
            id: "QW9_m4_A0 g3_H c2_7B",
            name: "REST APIs",
            accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
            topic: [
              {
                id: "QW9_s1_A0 m4_H g3_7B c2_D2E",
                name: "REST APIs",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s2_A0 m4_H g3_7B c2_D2E",
                name: "REST APIs | Cheat Sheet",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s3_A0 m4_H g3_7B c2_D2E",
                name: "MCQ Pratice - REST APIs",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s4_A0 m4_H g3_7B c2_D2E",
                name: "Coding Practice 8 - Node JS",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s5_A0 m4_H g3_7B c2_D2E",
                name: "Debugging Common Errors",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s6_A0 m4_H g3_7B c2_D2E",
                name: "Debugging Common Errors | Cheat Sheet",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s7_A0 m4_H g3_7B c2_D2E",
                name: " Debugging Common Errors | Part 2",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s8_A0 m4_H g3_7B c2_D2E",
                name: "Debugging Common Errors | Part 2 | Cheat Sheet",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s9_A0 m4_H g3_7B c2_D2E",
                name: "MCQ Pratice - Debugging Common Errors",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
            ],
          },
          {
            id: "QW9_m5_A0 g3_H c2_7B",
            name: "Authentication",
            accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
            topic: [
              {
                id: "QW9_s1_A0 m5_H g3_7B c2_D2E",
                name: "Authentication",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s2_A0 m5_H g3_7B c2_D2E",
                name: "Authentication | Cheat Sheet",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s3_A0 m5_H g3_7B c2_D2E",
                name: "MCQ Pratice - Authentication",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s4_A0 m5_H g3_7B c2_D2E",
                name: "Coding Practice 9 - Node JS",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s5_A0 m5_H g3_7B c2_D2E",
                name: "Authentication | Part 2",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s6_A0 m5_H g3_7B c2_D2E",
                name: "Authentication | Part 2 | Cheat Sheet",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s7_A0 m5_H g3_7B c2_D2E",
                name: "MCQ Pratice - Authentication | Part 2",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s8_A0 m5_H g3_7B c2_D2E",
                name: "Authentication | Part 3",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s9_A0 m5_H g3_7B c2_D2E",
                name: "Authentication | Part 3 | Cheat Sheet",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s10_A0 m5_H g3_7B c2_D2E",
                name: "MCQ Pratice - Authentication | Part 3",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s11_A0 m5_H g3_7B c2_D2E",
                name: "Coding Practice 10 - Node JS",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
            ],
          },
          {
            id: "QW9_m6_A0 g3_H c2_7B",
            name: "Assignments",
            accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
            topic: [
              {
                id: "QW9_s1_A0 m6_H g3_7B c2_D2E",
                name: "Coding Assignment 1 - Node JS",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s2_A0 m6_H g3_7B c2_D2E",
                name: "Coding Assignment 2 - Node JS",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
            ],
          },
          {
            id: "QW9_m7_A0 g3_H c2_7B",
            name: "Mock Tests",
            accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
            topic: [
              {
                id: "QW9_s1_A0 m7_H g3_7B c2_D2E",
                name: "MCQ Test 1 - Node JS",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s2_A0 m7_H g3_7B c2_D2E",
                name: "MCQ Test 2 - Node JS",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s3_A0 m7_H g3_7B c2_D2E",
                name: "MCQ Test 3 - Node JS",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
            ],
          },
        ],
      },
      {
        id: "g3 c3",
        title: "Python Interview Kit",
        progress: 0,
        accessibleTo: ["zorvixe_pro", "zorvixe_elite"],
        modules: [
          {
            id: "QW9_m1_A0 g3_H c3_7B",
            name: "Python Interview Kit",
            accessibleTo: ["zorvixe_pro", "zorvixe_elite"],
            topic: [],
          },
        ],
      },
      {
        id: "g3 c4",
        title: "React JS Getting started: React JS",
        progress: 0,
        accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
        modules: [
          {
            id: "QW9_m1_A0 g3_H c4_7B",
            name: "Introduction to React JS",
            accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
            topic: [
              {
                id: "QW9_s1_A0 m1_H g3_7B c4_D2E",
                name: "Introduction to React JS",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s2_A0 m1_H g3_7B c4_D2E",
                name: "Introduction to React JS | Cheat Sheet",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s3_A0 m1_H g3_7B c4_D2E",
                name: "MCQ Pratice - Introduction to React JS",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s4_A0 m1_H g3_7B c4_D2E",
                name: "Coding Pratice 1 - Introduction to React JS",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s5_A0 m1_H g3_7B c4_D2E",
                name: "Components & Pros",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s6_A0 m1_H g3_7B c4_D2E",
                name: "Components & Pros | Cheat Sheet",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s7_A0 m1_H g3_7B c4_D2E",
                name: "MCQ Pratice - Components & Pros",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s8_A0 m1_H g3_7B c4_D2E",
                name: "Coding Pratice 2 - Components & Pros",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s9_A0 m1_H g3_7B c4_D2E",
                name: "Lists & Keys",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s10_A0 m1_H g3_7B c4_D2E",
                name: "Lists & Keys | Cheat Sheet",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s11_A0 m1_H g3_7B c4_D2E",
                name: "MCQ Pratice - Lists & Keys",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s12_A0 m1_H g3_7B c4_D2E",
                name: "Coding Pratice 3 - Lists & Keys",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
            ],
          },
          {
            id: "QW9_m2_A0 g3_H c4_7B",
            name: "Class Component and State",
            accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
            topic: [
              {
                id: "QW9_s1_A0 m2_H g3_7B c4_D2E",
                name: "Class Component and State",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s2_A0 m2_H g3_7B c4_D2E",
                name: "Class Component and State | Cheat Sheet",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s3_A0 m2_H g3_7B c4_D2E",
                name: "A Note on React Versions",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s4_A0 m2_H g3_7B c4_D2E",
                name: "MCQ Pratice - Class Component and State",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s5_A0 m2_H g3_7B c4_D2E",
                name: "Coding Pratice 4- Class Component and State",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s6_A0 m2_H g3_7B c4_D2E",
                name: "Conditional Rendering",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s7_A0 m2_H g3_7B c4_D2E",
                name: "Conditional Rendering | Cheat Sheet",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s8_A0 m2_H g3_7B c4_D2E",
                name: "MCQ Pratice - Conditional Rendering",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s9_A0 m2_H g3_7B c4_D2E",
                name: "Coding Pratice 5 - Conditional Rendering",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
            ],
          },
          {
            id: "QW9_m3_A0 g3_H c4_7B",
            name: "Class Component and State 2",
            accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
            topic: [
              {
                id: "QW9_s1_A0 m3_H g3_7B c4_D2E",
                name: "Class Component and State | Part 2",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s2_A0 m3_H g3_7B c4_D2E",
                name: "Class Component and State | Cheat Sheet | Part 2",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s3_A0 m3_H g3_7B c4_D2E",
                name: "MCQ Pratice - Class Component and State | Part 2",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s4_A0 m3_H g3_7B c4_D2E",
                name: "Coding Pratice 6- Class Component and State | Part 2",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s5_A0 m3_H g3_7B c4_D2E",
                name: "Coding Pratice 7- Class Component and State | Part 2",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s6_A0 m3_H g3_7B c4_D2E",
                name: "Coding Pratice 8- Class Component and State | Part 2",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s7_A0 m3_H g3_7B c4_D2E",
                name: "Assignment 1",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
            ],
          },
          {
            id: "QW9_m4_A0 g3_H c4_7B",
            name: "Common Mistakes",
            accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
            topic: [
              {
                id: "QW9_s1_A0 m4_H g3_7B c4_D2E",
                name: "Common Mistakes",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s2_A0 m4_H g3_7B c4_D2E",
                name: "Common Mistakes | Cheat Sheet",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s3_A0 m4_H g3_7B c4_D2E",
                name: "MCQ Pratice - Common Mistakes",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s4_A0 m4_H g3_7B c4_D2E",
                name: "Coding Pratice 9 - Common Mistakes",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s5_A0 m4_H g3_7B c4_D2E",
                name: "Coding Pratice 10 - Common Mistakes",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
            ],
          },
          {
            id: "QW9_m5_A0 g3_H c4_7B",
            name: "Debugging",
            accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
            topic: [
              {
                id: "QW9_s1_A0 m5_H g3_7B c4_D2E",
                name: "Debugging using Developer Tools",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s2_A0 m5_H g3_7B c4_D2E",
                name: "Debugging using Developer Tools | Cheat Sheet",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s3_A0 m5_H g3_7B c4_D2E",
                name: "MCQ Pratice - Debugging using Developer Tools",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s4_A0 m5_H g3_7B c4_D2E",
                name: "Coding Pratice 11 - Debugging using Developer Tools",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
            ],
          },
          {
            id: "QW9_m6_A0 g3_H c4_7B",
            name: "Working With Lists",
            accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
            topic: [
              {
                id: "QW9_s1_A0 m6_H g3_7B c4_D2E",
                name: "On Demand Session",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s2_A0 m6_H g3_7B c4_D2E",
                name: "On Demand Session1 | Cheat Sheet",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s3_A0 m6_H g3_7B c4_D2E",
                name: "MCQ Pratice - On Demand Session1",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s4_A0 m6_H g3_7B c4_D2E",
                name: "Coding Pratice 12 - On Demand Session",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s5_A0 m6_H g3_7B c4_D2E",
                name: "Coding Pratice 13 - On Demand Session",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s6_A0 m6_H g3_7B c4_D2E",
                name: "Coding Pratice 14 - On Demand Session",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s7_A0 m6_H g3_7B c4_D2E",
                name: "Coding Pratice 15 - On Demand Session",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s8_A0 m6_H g3_7B c4_D2E",
                name: "On Demand Session | Part 2",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s9_A0 m6_H g3_7B c4_D2E",
                name: "On Demand Session | Cheat Sheet | Part 2",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s10_A0 m6_H g3_7B c4_D2E",
                name: "MCQ Pratice - On Demand Session | Part 2",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s11_A0 m6_H g3_7B c4_D2E",
                name: "Coding Pratice 16 - On Demand Session",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s12_A0 m6_H g3_7B c4_D2E",
                name: "Coding Pratice 17 - On Demand Session",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s13_A0 m6_H g3_7B c4_D2E",
                name: "Coding Pratice 18 - On Demand Session",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s14_A0 m6_H g3_7B c4_D2E",
                name: "Coding Pratice 15 - On Demand Session",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
            ],
          },
          {
            id: "QW9_m7_A0 g3_H c4_7B",
            name: "Component Life Cycle",
            accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
            topic: [
              {
                id: "QW9_s1_A0 m7_H g3_7B c4_D2E",
                name: "Component Life Cycle",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s2_A0 m7_H g3_7B c4_D2E",
                name: "Component Life Cycle | Cheat Sheet",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s3_A0 m7_H g3_7B c4_D2E",
                name: "MCQ Pratice - Component Life Cycle",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s4_A0 m7_H g3_7B c4_D2E",
                name: "Coding Pratice 19 - Component Life Cycle",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s5_A0 m7_H g3_7B c4_D2E",
                name: "Coding Pratice 20 - Component Life Cycle",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s6_A0 m7_H g3_7B c4_D2E",
                name: "Coding Pratice 21 - Component Life Cycle",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s7_A0 m7_H g3_7B c4_D2E",
                name: "Assignment 2",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s8_A0 m7_H g3_7B c4_D2E",
                name: "Assignment 3",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
            ],
          },
          {
            id: "QW9_m8_A0 g3_H c4_7B",
            name: "React Router",
            accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
            topic: [
              {
                id: "QW9_s1_A0 m8_H g3_7B c4_D2E",
                name: "Routing using React Router",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s2_A0 m8_H g3_7B c4_D2E",
                name: "Routing using React Router | Cheat Sheet",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s3_A0 m8_H g3_7B c4_D2E",
                name: "MCQ Pratice - Routing using React Router",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s4_A0 m8_H g3_7B c4_D2E",
                name: "Coding Pratice 22 - Component Life Cycle",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s5_A0 m8_H g3_7B c4_D2E",
                name: "Routing using React Router | Part 2",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s6_A0 m8_H g3_7B c4_D2E",
                name: "Routing using React Router | Part 3",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s7_A0 m8_H g3_7B c4_D2E",
                name: "Routing using React Router | Part 2 & 3| Cheat Sheet",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s8_A0 m8_H g3_7B c4_D2E",
                name: "MCQ Pratice - Routing using React Router | Part 2 & 3",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s9_A0 m8_H g3_7B c4_D2E",
                name: "Coding Pratice 23 - Component Life Cycle | Part 2",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s10_A0 m8_H g3_7B c4_D2E",
                name: "Coding Pratice 24 - Component Life Cycle | Part 3",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s11_A0 m8_H g3_7B c4_D2E",
                name: "Assignment 4",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s12_A0 m8_H g3_7B c4_D2E",
                name: "Common Mistakes | Part 2",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s13_A0 m8_H g3_7B c4_D2E",
                name: "Common Mistakes | Cheat Sheet | Part 2",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s14_A0 m8_H g3_7B c4_D2E",
                name: "MCQ Pratice - Common Mistakes | Part 2",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s15_A0 m8_H g3_7B c4_D2E",
                name: "Coding Pratice 25 - Common Mistakes | Part 2",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s16_A0 m8_H g3_7B c4_D2E",
                name: "Coding Pratice 26 - Common Mistakes | Part 2",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
            ],
          },
          {
            id: "QW9_m9_A0 g3_H c4_7B",
            name: "Authentication & Authorization",
            accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
            topic: [
              {
                id: "QW9_s1_A0 m9_H g3_7B c4_D2E",
                name: "Authentication & Authorization",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s2_A0 m9_H g3_7B c4_D2E",
                name: "Authentication & Authorization | Cheat Sheet",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s3_A0 m9_H g3_7B c4_D2E",
                name: "MCQ Pratice - Authentication & Authorization",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s4_A0 m9_H g3_7B c4_D2E",
                name: "Coding Pratice 27 - Authentication & Authorization",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s5_A0 m9_H g3_7B c4_D2E",
                name: "Authentication & Authorization | Part 2",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s6_A0 m9_H g3_7B c4_D2E",
                name: "Authentication & Authorization | Part 2 | Cheat Sheet",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s7_A0 m9_H g3_7B c4_D2E",
                name: "MCQ Pratice - Authentication & Authorization | Part 2",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s8_A0 m9_H g3_7B c4_D2E",
                name: "Coding Pratice 28 - Authentication & Authorization",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s9_A0 m9_H g3_7B c4_D2E",
                name: "Authentication & Authorization | Part 3",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s10_A0 m9_H g3_7B c4_D2E",
                name: "Authentication & Authorization | Part 3 | Cheat Sheet",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s11_A0 m9_H g3_7B c4_D2E",
                name: "MCQ Pratice - Authentication & Authorization | Part 3",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s12_A0 m9_H g3_7B c4_D2E",
                name: "Coding Pratice 29 - Authentication & Authorization",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s13_A0 m9_H g3_7B c4_D2E",
                name: "Common Mistakes | Part 3",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s14_A0 m9_H g3_7B c4_D2E",
                name: "Common Mistakes | Part 3 | Cheat Sheet",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s15_A0 m9_H g3_7B c4_D2E",
                name: "MCQ Pratice - Common Mistakes | Part 3",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s16_A0 m9_H g3_7B c4_D2E",
                name: "Coding Pratice 30 - Common Mistakes | Part 3",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s17_A0 m9_H g3_7B c4_D2E",
                name: "Coding Pratice 31 - Common Mistakes | Part 3",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
            ],
          },
          {
            id: "QW9_m10_A0 g3_H c4_7B",
            name: "Authentication & Authorization 2",
            accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
            topic: [
              {
                id: "QW9_s1_A0 m10_H g3_7B c4_D2E",
                name: "Authentication & Authorization | Part 4",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s2_A0 m10_H g3_7B c4_D2E",
                name: "Authentication & Authorization | Part 4 | Cheat Sheet",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s3_A0 m10_H g3_7B c4_D2E",
                name: "MCQ Pratice - Authentication & Authorization | Part 4",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s4_A0 m10_H g3_7B c4_D2E",
                name: "Coding Pratice 32 - Authentication & Authorization",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s5_A0 m10_H g3_7B c4_D2E",
                name: "Sorting Products",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s6_A0 m10_H g3_7B c4_D2E",
                name: "Sorting Products | Cheat Sheet",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s7_A0 m10_H g3_7B c4_D2E",
                name: "MCQ Pratice - Sorting Products",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s8_A0 m10_H g3_7B c4_D2E",
                name: "Coding Pratice 33 - Sorting Products",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s9_A0 m10_H g3_7B c4_D2E",
                name: "Coding Pratice 34 - Sorting Products",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s10_A0 m10_H g3_7B c4_D2E",
                name: "Coding Pratice 35 - Sorting Products",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
            ],
          },
          {
            id: "QW9_m11_A0 g3_H c4_7B",
            name: "More React Concepts",
            accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
            topic: [
              {
                id: "QW9_s1_A0 m11_H g3_7B c4_D2E",
                name: "More React Concepts",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s2_A0 m11_H g3_7B c4_D2E",
                name: "More React Concepts | Cheat Sheet",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },

              {
                id: "QW9_s3_A0 m11_H g3_7B c4_D2E",
                name: "MCQ Pratice - More React Concepts",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s4_A0 m11_H g3_7B c4_D2E",
                name: "Coding Pratice 36 - More React Concepts",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
            ],
          },
          {
            id: "QW9_m12_A0 g3_H c4_7B",
            name: "Third Party Packages",
            accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
            topic: [
              {
                id: "QW9_s1_A0 m12_H g3_7B c4_D2E",
                name: "Third Party Packages",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s2_A0 m12_H g3_7B c4_D2E",
                name: "Third Party Packages | Cheat Sheet",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s3_A0 m12_H g3_7B c4_D2E",
                name: "MCQ Pratice - Third Party Packages",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s4_A0 m12_H g3_7B c4_D2E",
                name: "Recharts | Reading Material",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s5_A0 m12_H g3_7B c4_D2E",
                name: "Coding Pratice 37 - Reading Material",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s6_A0 m12_H g3_7B c4_D2E",
                name: "React Chrono | Reading Material",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s7_A0 m12_H g3_7B c4_D2E",
                name: "Coding Pratice 38 - React Chrono",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s8_A0 m12_H g3_7B c4_D2E",
                name: "React Slick | Reading Material",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s9_A0 m12_H g3_7B c4_D2E",
                name: "Coding Pratice 39 - React Slick",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s10_A0 m12_H g3_7B c4_D2E",
                name: "React Popup | Reading Material",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s11_A0 m12_H g3_7B c4_D2E",
                name: "Coding Pratice 40 - React Popup",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
            ],
          },
          {
            id: "QW9_m13_A0 g3_H c4_7B",
            name: "Jobby App",
            accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
            topic: [
              {
                id: "QW9_s1_A0 m13_H g3_7B c4_D2E",
                name: "Assignment 5",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
            ],
          },
          {
            id: "QW9_m14_A0 g3_H c4_7B",
            name: "React Context",
            accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
            topic: [
              {
                id: "QW9_s1_A0 m14_H g3_7B c4_D2E",
                name: "React Context",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s2_A0 m14_H g3_7B c4_D2E",
                name: "React Context | Cheat Sheet",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s3_A0 m14_H g3_7B c4_D2E",
                name: "MCQ Pratice - React Context",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s4_A0 m14_H g3_7B c4_D2E",
                name: "React Context | Part 2",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s5_A0 m14_H g3_7B c4_D2E",
                name: "React Context | Part 2 | Cheat Sheet",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s6_A0 m14_H g3_7B c4_D2E",
                name: "MCQ Pratice - React Context | Part 2",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s7_A0 m14_H g3_7B c4_D2E",
                name: "Coding Pratice 41",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s8_A0 m14_H g3_7B c4_D2E",
                name: "React Context | Part 3",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s9_A0 m14_H g3_7B c4_D2E",
                name: "React Context | Part 3 | Cheat Sheet",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s10_A0 m14_H g3_7B c4_D2E",
                name: "MCQ Pratice - React Context | Part 3",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s11_A0 m14_H g3_7B c4_D2E",
                name: "Coding Pratice 42",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s12_A0 m14_H g3_7B c4_D2E",
                name: "React Context | Part 4",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s13_A0 m14_H g3_7B c4_D2E",
                name: "React Context | Part 4 | Cheat Sheet",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s14_A0 m14_H g3_7B c4_D2E",
                name: "MCQ Pratice - React Context | Part 4",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s15_A0 m14_H g3_7B c4_D2E",
                name: "Coding Pratice 43",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
            ],
          },
          {
            id: "QW9_m15_A0 g3_H c4_7B",
            name: "Styled Components",
            accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
            topic: [
              {
                id: "QW9_s1_A0 m15_H g3_7B c4_D2E",
                name: "Styled Components",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s2_A0 m15_H g3_7B c4_D2E",
                name: "Styled Components | Cheat Sheet",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s3_A0 m15_H g3_7B c4_D2E",
                name: "MCQ Pratice - Styled Components",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s4_A0 m15_H g3_7B c4_D2E",
                name: "Coding Pratice 44",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s4_A0 m15_H g3_7B c4_D2E",
                name: "Coding Pratice 45",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
            ],
          },
          {
            id: "QW9_m16_A0 g3_H c4_7B",
            name: "Assignments",
            accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
            topic: [
              {
                id: "QW9_s1_A0 m16_H g3_7B c4_D2E",
                name: "Assignments 6",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s2_A0 m16_H g3_7B c4_D2E",
                name: "Assignments 7",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
            ],
          },
          {
            id: "QW9_m17_A0 g3_H c4_7B",
            name: "Mock Tests",
            accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
            topic: [
              {
                id: "QW9_s1_A0 m17_H g3_7B c4_D2E",
                name: "Introduction to React JS",
                accessibleTo: ["zorvixe_core", "zorvixe_pro", "zorvixe_elite"],
              },
            ],
          },
          {
            id: "QW9_m18_A0 g3_H c4_7B",
            name: "React Js Course Exam",
            accessibleTo: ["zorvixe_pro", "zorvixe_elite"],
            topic: [
              {
                id: "QW9_s1_A0 m18_H g3_7B c4_D2E",
                name: "React Js Course Exam | Instructions",
                accessibleTo: ["zorvixe_pro", "zorvixe_elite"],
              },
              {
                id: "QW9_s2_A0 m18_H g3_7B c4_D2E",
                name: "React Js Course Exam",
                accessibleTo: ["zorvixe_pro", "zorvixe_elite"],
              },
            ],
          },
        ],
      },
      {
        id: "g3 c5",
        title: "Frontend Interview Kit",
        progress: 0,
        accessibleTo: ["zorvixe_pro", "zorvixe_elite"],
        modules: [
          {
            id: "QW9_m1_A0 g3_H c5_7B",
            name: "Frontend Interview Kit",
            accessibleTo: ["zorvixe_pro", "zorvixe_elite"],
            topic: [],
          },
        ],
      },
    ],
  },
];

// GoalsPDFView Component
const GoalsPDFView = ({ onSelectSubtopic }) => {
  const [expandedGoals, setExpandedGoals] = useState(new Set());
  const [expandedCourses, setExpandedCourses] = useState(new Set());

  const toggleGoal = (goalId) => {
    const newExpanded = new Set(expandedGoals);
    if (newExpanded.has(goalId)) {
      newExpanded.delete(goalId);
    } else {
      newExpanded.add(goalId);
    }
    setExpandedGoals(newExpanded);
  };

  const toggleCourse = (courseId) => {
    const newExpanded = new Set(expandedCourses);
    if (newExpanded.has(courseId)) {
      newExpanded.delete(courseId);
    } else {
      newExpanded.add(courseId);
    }
    setExpandedCourses(newExpanded);
  };

  const handleSubtopicSelect = (goal, course, module, topic) => {
    if (onSelectSubtopic) {
      onSelectSubtopic({
        topic: topic,
        goalTitle: goal.title,
        courseTitle: course.title,
        moduleName: module.name,
      });
    }
  };

  return (
    <div className="clvm-goals-pdf-view">
      <div className="clvm-pdf-header">
        <h2>Learning Goals Structure</h2>
        <p>Select a subtopic to link with your video</p>
      </div>

      <div className="clvm-goals-container">
        {goalsData.map((goal, goalIndex) => (
          <div
            key={goal.id}
            className="clvm-goal-section"
            style={{ borderLeftColor: goal.color }}
          >
            <div
              className="clvm-goal-header"
              onClick={() => toggleGoal(goal.id)}
            >
              <div className="clvm-goal-title">
                <span className="clvm-expand-icon">
                  {expandedGoals.has(goal.id) ? "▼" : "►"}
                </span>
                <h3>{goal.title}</h3>
                <span className="clvm-goal-progress">{goal.progress}%</span>
              </div>
            </div>

            {expandedGoals.has(goal.id) && (
              <div className="clvm-courses-container">
                {goal.courses.map((course, courseIndex) => (
                  <div key={course.id} className="clvm-course-section">
                    <div
                      className="clvm-course-header"
                      onClick={() => toggleCourse(course.id)}
                    >
                      <div className="clvm-course-title">
                        <span className="clvm-expand-icon">
                          {expandedCourses.has(course.id) ? "▼" : "►"}
                        </span>
                        <h4>{course.title}</h4>
                        <span className="clvm-course-progress">
                          {course.progress}%
                        </span>
                      </div>
                    </div>

                    {expandedCourses.has(course.id) && (
                      <div className="clvm-modules-container">
                        {course.modules.map((module, moduleIndex) => (
                          <div key={module.id} className="clvm-module-section">
                            <div className="clvm-module-header">
                              <h5>{module.name}</h5>
                              <span className="clvm-module-id">
                                ID: {module.id}
                              </span>
                            </div>
                            <div className="clvm-topics-container">
                              {module.topic.map((topic, topicIndex) => (
                                <div
                                  key={topic.id}
                                  className="clvm-topic-item"
                                  onClick={() =>
                                    handleSubtopicSelect(
                                      goal,
                                      course,
                                      module,
                                      topic
                                    )
                                  }
                                >
                                  <div className="clvm-topic-content">
                                    <span className="clvm-topic-number">
                                      {goalIndex + 1}.{courseIndex + 1}.
                                      {moduleIndex + 1}.{topicIndex + 1}
                                    </span>
                                    <span className="clvm-topic-name">
                                      {topic.name}
                                    </span>
                                  </div>
                                  <span className="clvm-topic-id">
                                    {topic.id}
                                  </span>
                                </div>
                              ))}
                            </div>
                          </div>
                        ))}
                      </div>
                    )}
                  </div>
                ))}
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default GoalsPDFView;
